/*
 * Sitenin TÜM içeriği bu dosyada.
 *
 * YENİ PROJE EKLEMEK: projects dizisine bir nesne ekle. Zorunlu alanlar:
 *   slug, name, year, kind, tagline, stack
 * Geri kalan her şey (gallery, detail, metrics, links) isteğe bağlı —
 * yoksa proje sayfası o bölümü hiç göstermez.
 *
 * GÖRSEL EKLEME: frontend/public/media/<slug>/ klasörüne at ve
 * gallery dizisine { src, caption } olarak yaz. İlk görsel kapak olur.
 * Görsel yoksa yerine şık bir yer tutucu çıkar, site bozulmaz.
 *
 * tier: "featured" → ana kart (büyük), "other" → ikincil kart (küçük)
 *
 * KAPAK: ana karttaki görsel. Tek tip görünsün diye scripts/make_covers.py
 * ile üretilir (cover: "/media/<klasör>/cover.jpg"). Yoksa ilk galeri görseli kullanılır.
 */

export const profile = {
  name: "Onur Çinkaya",
  role: {
    tr: "Full-Stack Developer · NinMen Studio kurucusu",
    en: "Full-Stack Developer · Founder of NinMen Studio",
  },
  location: { tr: "İzmir, Türkiye", en: "İzmir, Türkiye" },
  availability: {
    tr: "Uzaktan ve hibrit çalışmaya açık",
    en: "Open to remote and hybrid work",
  },
  email: "onurcinkaya26@gmail.com",
  telegram: "https://t.me/dikucgen",
  telegramHandle: "@dikucgen",
  github: "https://github.com/Tetherium",
  linkedin: "https://www.linkedin.com/in/onur-%C3%A7inkaya-737432259/",
  phone: "0505 095 0132",
  cvTr: "/OnurCinkayaCV.pdf",
  cvEn: "/OnurCinkaya_Resume_En.pdf",
};

/* ---------------------------------------------------------------- HERO */

export const hero = {
  thesis: {
    tr: ["İyi yazılım çalışan kod değil,", "ortadan kalkan bir iş yüküdür."],
    en: ["Good software isn't working code.", "It's a workload that disappears."],
  },
  intro: {
    tr: "Dokuz Eylül Bilgisayar Bilimleri son sınıf öğrencisiyim. NinMen Studio'da kendi ürünlerimizi geliştiriyor, hukuk bürolarından otomotiv bayilerine kadar müşterilerle birebir çalışarak ihtiyaçlarını yayındaki yazılıma dönüştürüyorum.",
    en: "I'm a final-year Computer Science student at Dokuz Eylül University. At NinMen Studio I build our own products, and I work one-on-one with clients, from law firms to car dealers, to turn what they need into software that ships.",
  },
};

/* ------------------------------------------------------------- PROJECTS */

const GH = "https://raw.githubusercontent.com/Tetherium";

export const projects = [
  /* ============================================================ ENSAFE */
  {
    slug: "ensafe",
    tier: "featured",
    cover: "/media/ensafe/cover.jpg",
    name: "Ensafe",
    year: "2026",
    org: "NinMen Studio",
    kind: { tr: "Sağlık uygulaması", en: "Health app" },
    status: { tr: "Google Play'de", en: "On Google Play" },
    live: true,
    tagline: {
      tr: "İlaç ve kozmetik ürünlerinin içeriğini kullanıcının alerji profiliyle karşılaştırıp risk puanı veren uygulama. Risk modelini kimya ve biyoloji mühendisleriyle birlikte kurduk.",
      en: "An app that checks the ingredients of medicines and cosmetics against a user's allergy profile and returns a risk score. We built the risk model together with chemistry and biology engineers.",
    },
    gallery: [
      {
        src: "/media/ensafe/01.png",
        ratio: "16 / 10",
        caption: { tr: "Ürünü tara, riski gör", en: "Scan a product, see the risk" },
      },
      {
        src: "/media/ensafe/02.png",
        ratio: "9 / 16",
        caption: { tr: "Ambalajı tara", en: "Scan the packaging" },
      },
      {
        src: "/media/ensafe/03.png",
        ratio: "9 / 16",
        caption: { tr: "Ürün arama", en: "Product search" },
      },
      {
        src: "/media/ensafe/04.png",
        ratio: "9 / 16",
        caption: { tr: "İçerik listesi", en: "Ingredient list" },
      },
      {
        src: "/media/ensafe/05.png",
        ratio: "9 / 16",
        caption: { tr: "Risk skoru", en: "Risk score" },
      },
      {
        src: "/media/ensafe/06.png",
        ratio: "9 / 16",
        caption: { tr: "Ana ekran", en: "Home screen" },
      },
      {
        src: "/media/ensafe/07.png",
        ratio: "9 / 16",
        caption: { tr: "Alerjen profili", en: "Allergen profile" },
      },
      {
        src: "/media/ensafe/08.png",
        ratio: "9 / 16",
        caption: { tr: "Analiz geçmişi", en: "Analysis history" },
      },
    ],
    metrics: [
      { value: "200.000+", label: { tr: "ürün", en: "products" } },
      { value: "3", label: { tr: "saniyede sonuç", en: "seconds to result" } },
      { value: "2", label: { tr: "platform: web ve mobil", en: "platforms: web and mobile" } },
    ],
    stack: [
      "React",
      "Capacitor",
      "PostgreSQL",
      "FastAPI",
      "Görüntüden barkod/ürün tanıma",
      "Docker",
      "Google Play",
    ],
    links: [],
    detail: {
      overview: {
        tr: "Ensafe, ilaç ve kozmetik ürünlerinin içeriğini kullanıcının alerji profiliyle çaprazlayıp risk puanı üreten bir sağlık uygulaması. NinMen Studio'nun ilk yayınlanan ürünü; Google Play'de.",
        en: "Ensafe is a health app that cross-references the ingredients of medicines and cosmetics against a user's allergy profile and produces a risk score. It's NinMen Studio's first shipped product, live on Google Play.",
      },
      problem: {
        tr: "İlaç ve kozmetik ambalajlarındaki içerik listeleri pratikte okunmuyor. Alerjen isimleri hem uzun hem de her markada farklı yazılıyor: aynı madde bir üründe ticari adıyla, diğerinde INCI adıyla, bir başkasında kısaltmasıyla geçebiliyor. Alerjisi olan biri için bu, eczane rafının önünde çözülemeyecek bir problem.",
        en: "In practice, nobody reads the ingredient lists on medicine and cosmetics packaging. Allergen names are long and written differently by every brand: the same substance may appear under a trade name on one product, its INCI name on another, an abbreviation on a third. For someone with allergies, that's an unsolvable problem standing in front of a pharmacy shelf.",
      },
      solution: {
        tr: "Kullanıcı ambalajın fotoğrafını çekiyor ya da ürünü arıyor. Yapay zekâ katmanı ambalajdan ürün adını ve barkodu okuyor, 200.000'den fazla ürün içeren PostgreSQL veritabanıyla eşleştiriyor. Risk motoru — kimya ve biyoloji mühendisleriyle birlikte kurduğumuz karar modeli — eşleşen içeriği kullanıcının kayıtlı alerji profiliyle çaprazlayıp tek bir risk puanına indiriyor. React + Capacitor sayesinde aynı kod tabanı hem web hem mobil olarak çalışıyor.",
        en: "The user photographs the packaging or searches for the product. An AI layer reads the product name and barcode off the packaging and matches it against a PostgreSQL database of 200,000+ products. The risk engine — a decision model we built together with chemistry and biology engineers — cross-references the matched ingredients with the user's stored allergy profile and reduces it to a single risk score. Thanks to React + Capacitor, one codebase runs as both web and mobile.",
      },
      highlights: [
        {
          title: { tr: "200.000+ ürünlük veritabanı", en: "A 200,000+ product database" },
          body: {
            tr: "Ürün verisi tek bir kaynaktan gelmiyor; farklı formatlardaki kayıtları normalize edip tek bir şemada birleştirdim. Barkod, ürün adı ve içerik listesi ayrı ayrı indekslendi, böylece arama hem isimden hem barkoddan çalışıyor.",
            en: "Product data doesn't come from a single source; I normalized records in different formats into one schema. Barcode, product name and ingredient list are indexed separately, so search works from either the name or the barcode.",
          },
        },
        {
          title: { tr: "Ambalajdan okuyan yapay zekâ", en: "AI that reads the packaging" },
          body: {
            tr: "Fotoğraftaki ambalajdan ürün adını ve barkodu çıkaran katman, eğik açı, parlama ve kısmi görünürlük gibi gerçek hayat koşullarına göre ayarlandı. Barkod okunamadığında isimden, isim okunamadığında barkoddan devam ediyor.",
            en: "The layer that extracts the product name and barcode from a photo is tuned for real-world conditions: skewed angles, glare, partial visibility. When the barcode can't be read it falls back to the name, and vice versa.",
          },
        },
        {
          title: {
            tr: "Mühendislerle kurulan risk motoru",
            en: "A risk engine built with domain engineers",
          },
          body: {
            tr: "\"İçinde var / yok\" ikili bir cevap yeterli değil. Motor, doğrudan alerjen, akraba madde ve çapraz bulaşma ihtimalini ayrı ağırlıklarla değerlendirip kullanıcıya tek bir puan ve gerekçe gösteriyor. Hangi maddenin hangi alerjenle akraba sayılacağını kimya ve biyoloji mühendisleriyle birlikte belirledik; ben bu alan bilgisini çalışan bir karar motoruna çevirdim. Sağlık alanında bir ürünü yalnızca mühendislik sezgisiyle kurmak doğru olmazdı.",
            en: "A binary \"contains / doesn't contain\" answer isn't enough. The engine weighs direct allergens, related substances and cross-contamination risk separately, then shows the user a single score with its reasoning. We decided which substance counts as related to which allergen together with chemistry and biology engineers; I turned that domain knowledge into a working decision engine. Building a health product on engineering intuition alone would have been wrong.",
          },
        },
        {
          title: { tr: "Tek kod tabanı, iki platform", en: "One codebase, two platforms" },
          body: {
            tr: "React ile yazılan arayüz, Capacitor ile imzalı Android derlemesine dönüşüyor ve Google Play'e gidiyor. Web sürümü aynı backend'i kullanıyor; sürüm yönetimi tek yerden ilerliyor.",
            en: "The React interface is packaged into a signed Android build with Capacitor and shipped to Google Play. The web version uses the same backend, so releases advance from a single place.",
          },
        },
      ],
      outcome: {
        tr: "Uygulama Google Play'de yayında. Kullanıcı bir ürünü taradığında sonuç üç saniyenin altında dönüyor; tüm altyapı kendi VPS'imde Docker ile çalışıyor.",
        en: "The app is live on Google Play. A scan returns a result in under three seconds, and the whole stack runs on my own VPS with Docker.",
      },
    },
  },

  /* ======================================================= CAT HUNTER */
  {
    slug: "cat-hunter",
    tier: "featured",
    cover: "/media/cat-hunter/cover.jpg",
    name: "Cat Hunter",
    year: "2026",
    org: "NinMen Studio",
    kind: { tr: "Biyometrik kimliklendirme", en: "Biometric identification" },
    status: { tr: "Beta · geliştiriliyor", en: "Beta · in development" },
    beta: true,
    tagline: {
      tr: "Sokak kedilerini fotoğraftan tanıyan uygulama. Kedinin yüzünden ve kürk deseninden bir parmak izi çıkarıp kayıtlı kedilerle eşleştiriyoruz.",
      en: "An app that recognizes street cats from a photo. We extract a fingerprint from the cat's face and coat pattern and match it against registered cats.",
    },
    gallery: [
      {
        src: "/media/cat-hunter/01.png",
        ratio: "16 / 10",
        caption: { tr: "Tara, tanı, koleksiyona ekle", en: "Scan, identify, collect" },
      },
      {
        src: "/media/cat-hunter/02.png",
        ratio: "9 / 16",
        caption: { tr: "Keşfet · yakındaki kediler", en: "Discover · cats nearby" },
      },
      {
        src: "/media/cat-hunter/03.png",
        ratio: "9 / 16",
        caption: { tr: "Kedi profili ve yorumlar", en: "Cat profile and comments" },
      },
      {
        src: "/media/cat-hunter/04.png",
        ratio: "9 / 16",
        caption: { tr: "Favori kediler", en: "Favorite cats" },
      },
      {
        src: "/media/cat-hunter/05.png",
        ratio: "9 / 16",
        caption: { tr: "Profil · puan ve seri", en: "Profile · points and streak" },
      },
    ],
    metrics: [
      { value: "%96", label: { tr: "ilk tahminde doğru kedi (mahalle ölçeği)", en: "right cat on the first guess (neighborhood scale)" } },
      { value: "49.434", label: { tr: "fotoğraf, 13.059 kedi kimliği", en: "photos, 13,059 cat identities" } },
      { value: "%34", label: { tr: "hatalı etiket ayıklandı", en: "of labels found wrong and removed" } },
    ],
    stack: [
      "PyTorch",
      "DINOv2 (Vision Transformer)",
      "ArcFace",
      "FastAPI",
      "SQLAlchemy 2.0 (async)",
      "PostgreSQL",
      "React 19",
      "Vite",
      "Capacitor",
      "Leaflet",
      "Docker",
      "nginx",
    ],
    links: [],
    chart: {
      title: {
        tr: "Aday havuzu küçüldükçe doğruluk artıyor",
        en: "Accuracy rises as the candidate pool shrinks",
      },
      series: [
        { key: "rank1", label: { tr: "İlk tahminde doğru kedi", en: "Right cat on the first guess" }, tone: "primary" },
        {
          key: "auto",
          label: { tr: "Tam otomatik doğru eşleşme", en: "Fully automatic correct match" },
          tone: "muted",
        },
      ],
      rows: [
        {
          label: { tr: "10 kedi · mahalle", en: "10 cats · neighborhood" },
          highlight: true,
          values: { rank1: 96.0, auto: 74.2 },
        },
        { label: { tr: "25 kedi", en: "25 cats" }, values: { rank1: 88.2, auto: 58.4 } },
        { label: { tr: "50 kedi", en: "50 cats" }, values: { rank1: 83.9, auto: 52.3 } },
        { label: { tr: "100 kedi", en: "100 cats" }, values: { rank1: 79.0, auto: 45.7 } },
        { label: { tr: "150 kedi", en: "150 cats" }, values: { rank1: 75.7, auto: 41.6 } },
      ],
      max: 100,
      unit: "%",
      note: {
        tr: "\"İlk tahminde doğru kedi\" teknik adıyla Rank-1 doğruluk: sistemin en benzer bulduğu kedinin gerçekten doğru kedi olma oranı. DINOv2, ince ayar yapılmadan, yanlış birleştirme oranı %10'a sabitlenerek; eğitimde hiç görülmemiş kediler üzerinde ölçüldü.",
        en: "\"Right cat on the first guess\" is Rank-1 accuracy: how often the cat the system ranks most similar is actually the right one. DINOv2, without fine-tuning, with the false-merge rate fixed at 10%; measured on cats never seen during training.",
      },
    },
    detail: {
      overview: {
        tr: "Sokak kedilerini fotoğraftan tanıyan, isimlendiren ve haritada gösteren mobil uygulama. İnsan parmak izi gibi, her kedinin yüz yapısı ve kürk deseni de kendine özgü. Uygulama bu özellikleri fotoğraftan çıkarıp sayısal bir parmak izine çeviriyor ve veritabanındaki kedilerle karşılaştırıyor. Uygulama uçtan uca çalışıyor; tanıma modeli beta aşamasında.",
        en: "A mobile app that recognizes, names and maps street cats from photos. Like a human fingerprint, every cat's face structure and coat pattern is unique. The app extracts those features from a photo, turns them into a numeric fingerprint and compares it against the cats in the database. The app works end to end; the recognition model is in beta.",
      },
      problem: {
        tr: "Mahalle kedileri topluluklar tarafından besleniyor ve takip ediliyor, ama bu takip dağınık ve sözlü. \"Sarı tekir\" diye bilinen kedi üç sokak ötede başka bir isimle biliniyor; kaybolduğunda kimse fotoğrafını eşleştiremiyor; kaç kedinin beslendiği kayıt altında değil.",
        en: "Neighborhood cats are fed and watched by local communities, but that tracking is scattered and verbal. The cat known as \"the ginger tabby\" goes by another name three streets over; when it disappears nobody can match its photo; and how many cats are being fed is recorded nowhere.",
      },
      solution: {
        tr: "Kullanıcı fotoğrafı çekiyor, GPS konumu ve zaman damgası birlikte kaydediliyor. Görüntü derin öğrenme modeliyle normalize edilmiş bir vektöre dönüşüyor, konum ve zaman bilgisiyle aday havuzu daraltılıyor, kalan adaylarla kosinüs benzerliği hesaplanıyor. Benzerlik eşiği aşıyorsa kedi tanınmış sayılıyor, aşmıyorsa yeni kedi olarak kaydediliyor. Bir kedi tek fotoğrafla değil, onaylanmış tüm gözlemlerinin ortalama vektörüyle temsil ediliyor.",
        en: "The user takes a photo; GPS location and timestamp are stored with it. A deep learning model turns the image into a normalized vector, location and time narrow the candidate pool, and cosine similarity is computed against what remains. Above the threshold the cat counts as recognized; below it, it's registered as a new cat. A cat is represented not by one photo but by the mean vector of all its confirmed sightings.",
      },
      highlights: [
        {
          title: {
            tr: "Verinin üçte biri yanlış etiketliydi",
            en: "A third of the data was mislabeled",
          },
          body: {
            tr: "Projenin en kritik adımı model değil, veri temizliğiydi. İki bağımsız hata buldum: bir karede birden fazla kedi varken nesne tespitinin hepsini aynı kimlikle kaydetmesi (%10,8) ve sahiplendirme ilanlarında tekrar kullanılan stok fotoğraflar (%23,5). MD5 özet karşılaştırmasında 17.276 dosyanın birebir aynı olduğu ve 4.554 farklı kimliğe dağıldığı çıktı; en uç örnekte tek bir fotoğraf 513 ayrı kedinin kimliği olarak etiketlenmişti. 73.507 fotoğrafı 49.434'e indirdim.",
            en: "The most critical step wasn't the model, it was cleaning the data. I found two independent faults: object detection cropping every cat in a multi-cat frame under the same identity (10.8%), and stock photos reused across adoption listings (23.5%). An MD5 comparison showed 17,276 files were byte-identical and spread across 4,554 different identities; in the worst case a single photo was labeled as the identity of 513 separate cats. I cut 73,507 photos down to 49,434.",
          },
        },
        {
          title: {
            tr: "Kendi eğittiğim model eğitilmemişinden kötüydü",
            en: "My own trained model was worse than an untrained one",
          },
          body: {
            tr: "İlk aşamada ResNet-50 tabanlı, triplet loss ile eğitilmiş bir model geliştirmiştim. Eğitim sırasında izlediğim doğruluk %97,4'e çıkmıştı. Sistematik ölçüm altyapısını kurduğumda gerçek Rank-1 değerinin %30,5 olduğu ortaya çıktı — eğitilmemiş ImageNet ResNet-50 aynı testte %52,1 alıyordu. Eğitim modeli geliştirmemiş, bozmuştu. Kök neden: 16.000 kimlik arasından rastgele seçilen negatif örnek neredeyse her zaman bariz farklı bir kediydi, üçlüler marjı ilk epoch'ta sağlayıp gradyan üretmeyi bırakıyordu; buna BatchNorm tutarsızlığı ve etiket gürültüsü eklenince izlenen gösterge doymuştu. Bu teşhis projenin yönünü değiştirdi.",
            en: "Early on I'd trained a ResNet-50 model with triplet loss. The accuracy I watched during training climbed to 97.4%. When I built proper evaluation, real Rank-1 turned out to be 30.5% — an untrained ImageNet ResNet-50 scored 52.1% on the same test. Training hadn't improved the model, it had broken it. Root cause: a negative sampled at random from 16,000 identities was almost always an obviously different cat, so triplets satisfied the margin in the first epoch and stopped producing gradient; add BatchNorm inconsistency and label noise, and the metric I was watching had saturated. That diagnosis changed the direction of the project.",
          },
        },
        {
          title: { tr: "Üç soru, üç ayrı metrik", en: "Three questions, three separate metrics" },
          body: {
            tr: "\"Model iyi mi?\" tek bir soru değil. Kayıtlı kediler arasında bu hangisi (Rank-1, Rank-5, mAP), bu iki fotoğraf aynı kedi mi (TAR@FAR, ROC-AUC) ve bu hiç görülmemiş yeni bir kedi mi (açık küme analizi) ayrı ayrı ölçülüyor. Aynı kedinin fotoğrafları asla hem eğitim hem test setinde bulunmuyor; benzerlik eşiği tahmin edilmiyor, kabul edilebilir yanlış birleştirme oranı sabitlenip eğriden okunuyor.",
            en: "\"Is the model good?\" isn't one question. Which of the enrolled cats is this (Rank-1, Rank-5, mAP), are these two photos the same cat (TAR@FAR, ROC-AUC), and is this a cat never seen before (open-set analysis) are each measured separately. A cat's photos never appear in both the training and test sets, and the similarity threshold isn't guessed — the acceptable false-merge rate is fixed and the threshold read off the curve.",
          },
        },
        {
          title: { tr: "Coğrafi öncelik: hız değil, doğruluk", en: "Geographic priority: accuracy, not speed" },
          body: {
            tr: "Bugün Ankara'da görülen bir kedi yarın İstanbul'da olamaz. Ama bu sert bir mesafe filtresi değil — kediler sahiplenilebilir, taşınabilir. Mesafe ve geçen süre bir benzerlik ek ücretine çevriliyor: uzaktaki aday elenmiyor, kazanabilmek için daha yüksek görsel benzerlik göstermesi gerekiyor, ek ücret de tavanlı. Bu bir performans optimizasyonu değil: açık küme problemlerinde yanlış eşleştirme riski aday sayısıyla büyüdüğü için, havuzu mahalle ölçeğine indirmek doğruluğu doğrudan artırıyor. Yukarıdaki grafik bunun sayısal gerekçesi.",
            en: "A cat seen in Ankara today can't be in Istanbul tomorrow. But this isn't a hard distance filter — cats get adopted, cats move. Distance and elapsed time become a similarity surcharge: a distant candidate isn't eliminated, it just has to show greater visual similarity to win, and the surcharge is capped. This isn't a performance optimization: because false-match risk in open-set problems grows with the number of candidates, shrinking the pool to neighborhood scale raises accuracy directly. The chart above is the numeric case for it.",
          },
        },
        {
          title: { tr: "Model seçimi ölçümle yapıldı", en: "The model was chosen by measurement" },
          body: {
            tr: "Dört aday görsel temel model aynı protokolde karşılaştırıldı (300 kedilik havuz): DINOv2-base %60,2 Rank-1 ile açık ara önde; ImageNet ResNet-50 %47,5; hayvan yeniden kimliklendirmesi için özel eğitilmiş MegaDescriptor-L-384 ise %52,7'de kaldı. Hayvana özel modelin genel amaçlı bir modelin gerisinde kalması dikkat çekiciydi: MegaDescriptor yaban hayatı desenlerine (zebra, leopar) ayarlı ve kedi kimliğine genellemiyor.",
            en: "Four candidate vision foundation models were compared under the same protocol (300-cat pool): DINOv2-base led clearly at 60.2% Rank-1; ImageNet ResNet-50 reached 47.5%; and MegaDescriptor-L-384, trained specifically for animal re-identification, stalled at 52.7%. That an animal-specific model trailed a general-purpose one was striking: MegaDescriptor is tuned to wildlife patterns like zebra and leopard, and doesn't generalize to cat identity.",
          },
        },
        {
          title: { tr: "Uygulama tarafı", en: "The application side" },
          body: {
            tr: "Model tek başına ürün değil. Arkada FastAPI ve async SQLAlchemy üzerinde JWT kimlik doğrulama, rol tabanlı yetkilendirme, IP bazlı istek sınırlama ve moderasyon denetim kaydı var; 31 otomatik test izole SQLite üzerinde çalışıyor. Kapak fotoğrafı sorgularındaki N+1 problemini pencere fonksiyonuyla çözdüm: 500 kedilik bir istek 501 sorgu yerine 2 sorgu. Model çıkarımı iş parçacığı havuzuna alınarak olay döngüsünün bloke olması engellendi. Ön yüz React 19 + Vite, harita Leaflet, mobil paketleme Capacitor.",
            en: "A model on its own isn't a product. Behind it sit FastAPI and async SQLAlchemy with JWT auth, role-based authorization, IP rate limiting and an audit trail for moderation; 31 automated tests run against an isolated SQLite database. I solved the N+1 problem in cover-photo queries with a window function: a 500-cat request now costs 2 queries instead of 501. Model inference moved to a thread pool so it can't block the event loop. The front end is React 19 + Vite, the map is Leaflet, and mobile packaging is Capacitor.",
          },
        },
      ],
      outcome: {
        tr: "Uygulama uçtan uca çalışır durumda: backend, web arayüzü ve Android paketi hazır, Docker ile dağıtılıyor. Devam eden beta işleri: DINOv2 modelinin uygulamaya entegrasyonu, ArcFace ile ince ayar eğitimi (boru hattı hazır, GPU çalıştırmasını bekliyor) ve sistemin otomatik birleştirme yerine öneri sunduğu, kullanıcının doğruladığı eşleştirme akışı. Ölçümler sahiplendirme sitesi fotoğraflarıyla yapıldığı için — bir kedinin fotoğrafları çoğunlukla aynı oturumda ve benzer arka planda — bu değerler gerçek sokak koşulları için bir üst sınır olarak okunmalı.",
        en: "The app works end to end: backend, web interface and Android package are ready and deployed with Docker. Still in beta: integrating the DINOv2 model into the app, fine-tuning with ArcFace (the pipeline is ready and waiting on a GPU run), and a matching flow where the system proposes rather than auto-merges and the user confirms. Because the measurements come from adoption-site photos — where a cat's pictures were mostly taken in one session against a similar background — these figures should be read as an upper bound for real street conditions.",
      },
    },
  },

  /* ==================================================== TICARET SICILI */
  {
    slug: "ticaret-sicili",
    tier: "featured",
    cover: "/media/ticaret-sicili/cover.jpg",
    name: { tr: "Ticaret Sicili Takip", en: "Trade Registry Tracker" },
    year: "2026",
    org: "NinMen Studio",
    kind: { tr: "Müşteri projesi · masaüstü", en: "Client project · desktop" },
    status: { tr: "Lisansla satılıyor", en: "Sold by license" },
    live: true,
    tagline: {
      tr: "Bir hukuk bürosunun isteğiyle başladı. Avukatlarla birebir çalışarak Ticaret Sicili Gazetesi'nin günlük taramasını otomatikleştiren, lisansla satılan bir masaüstü ürüne dönüştürdüm.",
      en: "It started as a request from a law firm. Working one-on-one with the lawyers, I turned their daily Trade Registry Gazette screening into an automated desktop product sold by license.",
    },
    galleryWide: true,
    gallery: [
      {
        src: "/media/ticaret-sicili/01.png",
        ratio: "1177 / 770",
        caption: { tr: "Yeni ilanlar, tarama sürerken", en: "New notices, mid-scan" },
      },
      {
        src: "/media/ticaret-sicili/02.png",
        ratio: "1175 / 776",
        caption: { tr: "Arşiv · 11.425 ilan", en: "Archive · 11,425 notices" },
      },
      {
        src: "/media/ticaret-sicili/03.png",
        ratio: "1179 / 774",
        caption: { tr: "Takip listesi ve şirket ekleme", en: "Watchlist and adding companies" },
      },
      {
        src: "/media/ticaret-sicili/04.png",
        ratio: "1174 / 769",
        caption: { tr: "Lisans ekranı", en: "License screen" },
      },
    ],
    metrics: [
      { value: "6 sa → 5 dk", label: { tr: "günlük tarama", en: "daily screening" } },
      { value: "0", label: { tr: "kaçan ilan", en: "missed notices" } },
      { value: "1", label: { tr: "tıkla rapor gönderimi", en: "click to send the report" } },
    ],
    stack: ["Electron", "React", "TypeScript", "SQLite", "SMTP", "Lisans anahtarı", "Otomatik güncelleme"],
    links: [
      { label: "GitHub — sürümler", href: "https://github.com/Tetherium/Ticari-Sicil-Takip" },
    ],
    detail: {
      overview: {
        tr: "Bir hukuk bürosu, her sabah elle yaptığı gazete taramasını otomatikleştirmek için bize geldi. İhtiyacı avukatlarla birlikte masaya yatırdım, her sürümü onların geri bildirimiyle şekillendirdim. Ortaya çıkan araç, lisans anahtarıyla satılan bir ürüne dönüştü; gerçek müşterisi ve geliri olan ilk ürünüm.",
        en: "A law firm came to us wanting to automate the gazette screening they did by hand every morning. I worked through the need together with the lawyers and shaped every release around their feedback. The tool grew into a product sold by license key: my first with real paying customers.",
      },
      problem: {
        tr: "Bürolar Ticaret Sicili Gazetesi'ni her gün elle tarıyordu: ortalama altı saat. Bu süre yalnızca maliyet değil, aynı zamanda risk: gözden kaçan her ilan kaçan bir müşteri, bazen de kaçırılan bir yasal süre demek.",
        en: "Firms screened the Trade Registry Gazette by hand every day — about six hours. That time isn't just cost, it's risk: every missed notice is a missed client, and sometimes a missed legal deadline.",
      },
      solution: {
        tr: "Uygulama yeni ilanları kendisi çekiyor, büronun ilgi alanına göre önem derecesine sıralıyor, Excel raporu üretiyor ve SMTP üzerinden tek tıkla ilgili kişilere iletiyor. Kurulumdan sonra avukatın yapması gereken tek şey sabah raporu okumak.",
        en: "The app fetches new notices itself, ranks them by severity against the firm's areas of interest, builds an Excel report and sends it to the right people over SMTP in one click. After setup, all a lawyer has to do is read the morning report.",
      },
      highlights: [
        {
          title: { tr: "Müşteriyle birlikte tasarlandı", en: "Designed with the client" },
          body: {
            tr: "Hangi ilan türünün kritik sayılacağına, raporun kime ve hangi biçimde gideceğine avukatlarla birlikte karar verdik. Müvekkil grupları, önem kuralları ve Excel'den toplu şirket ekleme gibi özellikler doğrudan bu görüşmelerden çıktı.",
            en: "We decided with the lawyers which notice types count as critical and who receives the report, in what format. Client groups, severity rules and bulk company import from Excel all came straight out of those conversations.",
          },
        },
        {
          title: { tr: "Sessizce kırpılan sonuçlar", en: "Silently truncated results" },
          body: {
            tr: "Geliştirme sırasında resmî sitenin arama sonuçlarını belli bir sayıdan sonra hiçbir uyarı vermeden kestiğini fark ettim. Yani elle tarayan bir insan da, naif bir scraper da ilanların bir kısmını hiç görmüyordu. Sonuç sayısını bağımsız olarak doğrulayan, eksik varsa sorguyu bölüp tekrarlayan bir katman yazdım.",
            en: "During development I noticed the official site cut off search results past a certain count with no warning at all. Which means a human screening by hand — and a naive scraper — never saw part of the notices. I wrote a layer that independently verifies the result count and, when something's missing, splits the query and retries.",
          },
        },
        {
          title: { tr: "Önem sıralaması", en: "Severity ranking" },
          body: {
            tr: "Her ilan aynı değerde değil. İlan türü, şirket büyüklüğü ve büronun tanımladığı ilgi kriterlerine göre puanlanıp sıralanıyor; avukat listenin tamamını değil, üstünü okuyor.",
            en: "Not every notice matters equally. Each is scored and sorted by notice type, company size and the firm's own criteria, so the lawyer reads the top of the list rather than all of it.",
          },
        },
        {
          title: { tr: "Lisans anahtarı ve dağıtım", en: "Licensing and distribution" },
          body: {
            tr: "Ürün lisans anahtarıyla satılıyor; uygulama güncellemeleri kendiliğinden indiriyor, müşterinin elle kurulum dosyası indirmesine gerek yok.",
            en: "The product is sold by license key, and the app downloads its own updates — the customer never has to fetch an installer by hand.",
          },
        },
        {
          title: { tr: "Yerelde çalışan veri", en: "Data that stays local" },
          body: {
            tr: "İlan geçmişi SQLite'ta, kullanıcının kendi bilgisayarında tutuluyor ve büro verisi dışarı çıkmıyor. Hukuk bürolarıyla görüşürken en çok sorulan soru buydu; mimariyi baştan buna göre kurduk.",
            en: "Notice history lives in SQLite on the user's own machine, so firm data never leaves the office. It was the question law firms asked most often, so we built the architecture around it from day one.",
          },
        },
      ],
      outcome: {
        tr: "Günde yaklaşık altı saat süren manuel iş beş dakikaya indi. Ürün lisansla satılıyor ve aktif olarak kullanılıyor.",
        en: "Roughly six hours of daily manual work became five minutes. The product sells by license and is in active use.",
      },
    },
  },

  /* ============================================================ TOYOTA */
  {
    slug: "toyota-fiyat-analizi",
    tier: "featured",
    cover: "/media/toyota/cover.jpg",
    name: { tr: "Otomotiv Pazar İzleme Sistemi", en: "Automotive Market Monitor" },
    year: "2026",
    org: { tr: "Toyota Yetkili Bayisi", en: "Toyota Authorized Dealer" },
    kind: { tr: "Müşteri projesi · veri otomasyonu", en: "Client project · data automation" },
    status: { tr: "Teslim edildi", en: "Delivered" },
    live: false,
    tagline: {
      tr: "Bir Toyota bayisi için 21 markanın fiyatlarını otomatik takip eden ve rakiplerin gerçek satış fiyatını hesaplayan sistem. İhtiyacı bayi ekibiyle birlikte tanımlayıp uçtan uca teslim ettim.",
      en: "A system for a Toyota dealer that tracks prices across 21 brands automatically and computes competitors' real selling prices. I defined the need with the dealer's team and delivered it end to end.",
    },
    galleryWide: true,
    gallery: [
      {
        src: "/media/toyota/01.png",
        ratio: "16 / 10",
        caption: { tr: "Scraper kontrol · 21 marka", en: "Scraper control · 21 brands" },
      },
      {
        src: "/media/toyota/02.png",
        ratio: "1579 / 929",
        caption: {
          tr: "NPP analizi · Toyota ve rakipler (müşteriye ait sütunlar bulanıklaştırıldı)",
          en: "NPP analysis · Toyota vs rivals (client-owned columns blurred)",
        },
      },
      {
        src: "/media/toyota/03.png",
        ratio: "1305 / 923",
        caption: { tr: "Genel bakış", en: "Overview" },
      },
    ],
    metrics: [
      { value: "22.000+", label: { tr: "fiyat kaydı / 6 gün", en: "price records / 6 days" } },
      { value: "21", label: { tr: "marka izleniyor", en: "brands tracked" } },
      { value: "840+", label: { tr: "donanım versiyonu", en: "trim versions" } },
    ],
    stack: [
      "FastAPI",
      "WebSocket",
      "Flutter",
      "Selenium/Playwright",
      "OTP'li kurumsal giriş",
      "Excel/PDF raporlama",
    ],
    links: [],
    detail: {
      overview: {
        tr: "Bir Toyota yetkili bayisinin isteğiyle geliştirdiğim, Türkiye otomotiv pazarını izleyen ve rakiplerin gerçek satış fiyatını hesaplayan veri sistemi. Hangi rakip modelin hangi Toyota modeliyle karşılaştırılacağını ve panelde neyin görüneceğini bayinin satış ekibiyle birlikte belirledik; sistemi toplama aşamasından raporlamaya kadar teslim ettim.",
        en: "A data system I built at the request of a Toyota authorized dealer. It monitors the Turkish automotive market and computes competitors' real selling prices. We decided together with the dealer's sales team which rival model to compare against which Toyota, and what the dashboard should show; I delivered everything from data collection to reporting.",
      },
      problem: {
        tr: "Türkiye pazarında liste fiyatları haftada birkaç kez değişiyor. Daha önemlisi, liste fiyatı gerçek satış fiyatı değil: her marka gizli müşteri indirimi uyguluyor ve bayi rakibinin gerçekte kaç liraya sattığını bilmiyordu. Fiyat kararları tahminle veriliyordu.",
        en: "List prices in the Turkish market change several times a week. More importantly, the list price isn't the selling price: every brand runs quiet dealer discounts, and this dealer had no idea what its competitors actually charged. Pricing decisions were guesswork.",
      },
      solution: {
        tr: "21 markanın 200'den fazla modelini ve 840'tan fazla donanım versiyonunu izleyen bir scraper altyapısı kurdum. Öncelikli rakipler 2 saatte bir, tüm pazar 6 saatte bir taranıyor. Toplanan veri üzerine kurduğum panel fiyat değişimlerini bildiriyor, şüpheli sıçramaları karantinaya alıyor ve 24 muadil model üzerinden Net Fiyat Konumlandırması hesaplıyor.",
        en: "I built scraper infrastructure tracking 200+ models and 840+ trim versions across 21 brands. Priority competitors are scanned every 2 hours, the whole market every 6. On top of the collected data, the dashboard I built reports price changes, quarantines suspicious jumps, and computes Net Price Positioning across 24 equivalent models.",
      },
      highlights: [
        {
          title: { tr: "Net Fiyat Konumlandırması (NPP)", en: "Net Price Positioning (NPP)" },
          body: {
            tr: "Projenin can damarı. 24 muadil model eşleştirilip liste fiyatları ile piyasada gözlenen fiyatlar karşılaştırılıyor; aradaki fark rakibin gizli müşteri indirimini ortaya çıkarıyor. Bayi ilk kez rakibinin gerçek konumunu sayıyla görebildi.",
            en: "The heart of the project. 24 equivalent models are paired, and list prices are compared against observed market prices; the gap reveals the competitor's hidden discount. For the first time the dealer could see a rival's real position as a number.",
          },
        },
        {
          title: { tr: "Kirli veriye karantina", en: "Quarantine for dirty data" },
          body: {
            tr: "Scraper'lar bozuk veri çeker: sayfa yapısı değişir, bir sıfır kayar, kampanya fiyatı liste fiyatı sanılır. %30 üzeri her sıçrama otomatik karantinaya alınıp onaya düşüyor. Böylece tek bir hatalı kayıt tüm analizi zehirlemiyor.",
            en: "Scrapers pull broken data: page structures change, a zero slips, a campaign price gets read as the list price. Any jump above 30% is automatically quarantined for review, so a single bad record can't poison the whole analysis.",
          },
        },
        {
          title: { tr: "İki hızlı tarama", en: "Two scanning speeds" },
          body: {
            tr: "Tüm pazarı iki saatte bir taramak gereksiz ve riskli. Öncelikli rakipler 2, pazarın kalanı 6 saatte bir taranacak şekilde ayrıldı; hem güncellik korundu hem de yük makul kaldı.",
            en: "Scanning the entire market every two hours is both wasteful and risky. Priority competitors run on a 2-hour cycle and the rest of the market on 6, keeping data fresh while load stays reasonable.",
          },
        },
        {
          title: { tr: "Kurumsal giriş ve raporlar", en: "Enterprise login and reports" },
          body: {
            tr: "Panel OTP'li kurumsal girişle korunuyor, anlık değişimler WebSocket ile düşüyor, yönetim için Excel ve PDF raporları üretiliyor. Mobil tarafta Flutter arayüzü var.",
            en: "The dashboard is protected by OTP-secured corporate login, live changes arrive over WebSocket, and Excel and PDF reports are generated for management. The mobile side is a Flutter interface.",
          },
        },
      ],
      outcome: {
        tr: "İlk altı günde 22.000'den fazla fiyat kaydı toplandı. Sistem uçtan uca teslim edildi: toplama, doğrulama, analiz, panel ve raporlama.",
        en: "More than 22,000 price records in the first six days. The system was delivered end to end: collection, validation, analysis, dashboard and reporting.",
      },
    },
  },

  /* ========================================================== SPONTANO */
  {
    slug: "spontano",
    tier: "featured",
    cover: "/media/spontano/cover.jpg",
    name: "Spontano",
    year: "2026",
    org: "NinMen Studio",
    kind: { tr: "Rota planlayıcı", en: "Route planner" },
    status: { tr: "Yayında", en: "Live" },
    live: true,
    tagline: {
      tr: "Konumuna, vaktine ve ilgi alanlarına göre gezi rotası çıkaran uygulama. Mekânların açık olup olmadığını ve hava durumunu hesaba katıyor.",
      en: "An app that builds a sightseeing route from your location, free time and interests, accounting for opening hours and the weather.",
    },
    gallery: [
      {
        src: "/media/spontano/01.png",
        ratio: "16 / 10",
        caption: { tr: "Üç dokunuşta bugünün rotası", en: "Today's route in three taps" },
      },
      {
        src: "/media/spontano/02.png",
        ratio: "9 / 16",
        caption: { tr: "Üretilen rota", en: "A generated route" },
      },
      {
        src: "/media/spontano/03.png",
        ratio: "9 / 16",
        caption: { tr: "Duraklar harita üzerinde", en: "Stops on the map" },
      },
      {
        src: "/media/spontano/04.png",
        ratio: "9 / 16",
        caption: { tr: "Şehir seçimi", en: "Choosing a city" },
      },
    ],
    metrics: [
      { value: "2", label: { tr: "harita kaynağı birleştirildi", en: "map sources merged" } },
      { value: "4", label: { tr: "girdi: konum, süre, ulaşım, ilgi", en: "inputs: place, time, transport, interests" } },
    ],
    stack: ["React", "Google Maps API", "OpenStreetMap", "PostgreSQL", "Docker", "VPS"],
    links: [],
    detail: {
      overview: {
        tr: "Elindeki boş zamanı gezilebilir bir rotaya çeviren planlayıcı. NinMen Studio ürünü, yayında.",
        en: "A planner that turns the free time you have into a route you can actually walk. A NinMen Studio product, live.",
      },
      problem: {
        tr: "Gezi önerisi veren uygulamalar herkese aynı on yeri söylüyor. Daha kötüsü, o yerlerin o an açık olup olmadığını, oraya nasıl gidileceğini ve dışarıda yağmur yağıp yağmadığını umursamıyorlar. Sonuç: kapalı bir müzenin önünde durmak.",
        en: "Trip planners hand everyone the same ten places. Worse, they ignore whether those places are open right now, how you'd get there, and whether it's raining outside. The result: standing in front of a closed museum.",
      },
      solution: {
        tr: "Spontano dört girdiyle çalışıyor: neredesin, ne kadar vaktin var, nasıl geziyorsun ve neyden hoşlanıyorsun. Bunların üzerine mekânların çalışma saatlerini ve anlık hava durumunu koyup gerçekten yürünebilir bir rota üretiyor. Aynı girdilerle iki kez aynı rota çıkmıyor.",
        en: "Spontano works from four inputs: where you are, how much time you have, how you're getting around, and what you enjoy. On top of that it layers opening hours and live weather to produce a route you can actually walk. The same inputs never give you the same route twice.",
      },
      highlights: [
        {
          title: { tr: "İki harita kaynağı", en: "Two map sources" },
          body: {
            tr: "Google Maps API ve OpenStreetMap birlikte kullanılıyor. Birinde eksik olan mekân bilgisi diğerinden tamamlanıyor; çalışma saati ve konum verisi çapraz doğrulanıyor.",
            en: "Google Maps API and OpenStreetMap are used together. Venue data missing from one is completed by the other, and opening hours and locations are cross-checked.",
          },
        },
        {
          title: { tr: "Açık mı, kapalı mı", en: "Open or closed" },
          body: {
            tr: "Rota üretilirken her durağın o saatte açık olup olmadığı kontrol ediliyor. Kapalı mekân rotaya hiç girmiyor — öneri listesinde görünüp hayal kırıklığı yaratmıyor.",
            en: "While building a route, every stop is checked for whether it's open at that hour. A closed venue never enters the route, so it can't show up and disappoint.",
          },
        },
        {
          title: { tr: "Hava durumuna göre", en: "Weather-aware" },
          body: {
            tr: "Yağmurlu bir öğleden sonra açık hava rotası anlamsız. Anlık hava durumu, iç ve dış mekân dengesini değiştiren bir girdi olarak rota üreticisine bağlı.",
            en: "An outdoor route makes no sense on a rainy afternoon. Live weather feeds into the generator as an input that shifts the indoor/outdoor balance.",
          },
        },
        {
          title: { tr: "Global skor tablosu", en: "Global leaderboard" },
          body: {
            tr: "Tamamlanan rotalar puan yazıyor. Gezmek tek seferlik bir eylem olmaktan çıkıp devam eden bir şeye dönüşüyor.",
            en: "Completed routes earn points, turning a one-off outing into something you keep coming back to.",
          },
        },
      ],
      outcome: {
        tr: "Uygulama yayında; altyapı kendi VPS'imde Docker ile çalışıyor.",
        en: "The app is live, running on my own VPS with Docker.",
      },
    },
  },

  /* ========================================================= CHARON-OS */
  {
    slug: "charon-os",
    tier: "featured",
    cover: "/media/charon-os/cover.jpg",
    name: "Charon-OS",
    year: "2026",
    org: { tr: "DEÜ Bitirme Projesi", en: "DEU Graduation Project" },
    kind: { tr: "Bitirme projesi · yapay zekâ", en: "Graduation project · AI" },
    status: { tr: "GitHub'da açık kaynak", en: "Open source on GitHub" },
    live: true,
    tagline: {
      tr: "Üç kişilik ekiple geliştirdiğimiz bitirme projemiz. Sesli komutla çalışan, ekranı görüp yorumlayan ve bilgisayarı kendisi kullanan otonom yapay zekâ asistanı.",
      en: "Our three-person graduation project: an autonomous AI assistant that takes voice commands, understands the screen and operates the computer itself.",
    },
    gallery: [
      {
        src: "/media/charon-os/01.png",
        ratio: "16 / 10",
        caption: { tr: "Ana arayüz", en: "Main interface" },
      },
      {
        src: `${GH}/Charon-OS/main/system_architecture.png`,
        caption: { tr: "Sistem mimarisi", en: "System architecture" },
      },
      {
        src: `${GH}/Charon-OS/main/waa_comparison_chart.png`,
        caption: { tr: "Performans karşılaştırması", en: "Performance comparison" },
      },
      {
        src: `${GH}/Charon-OS/main/verification_flowchart.png`,
        caption: { tr: "Doğrulama akışı", en: "Verification flow" },
      },
    ],
    metrics: [
      { value: "3", label: { tr: "kişilik ekip", en: "person team" } },
      { value: "8", label: { tr: "yetenek modülü", en: "capability modules" } },
    ],
    stack: ["Python", "PyQt6", "Gemini Live API", "Playwright", "Windows UI Automation", "Yerel LLM", "Yerel OCR"],
    links: [
      { label: "GitHub", href: "https://github.com/Tetherium/Charon-OS" },
      {
        label: { tr: "Bitirme tezi (PDF)", en: "Graduation thesis (PDF, Turkish)" },
        href: "https://csc.deu.edu.tr/wp-content/uploads/2026/06/92.pdf",
      },
    ],
    detail: {
      overview: {
        tr: "Dokuz Eylül Üniversitesi Bilgisayar Bilimleri bölümündeki bitirme projemiz. Tezin adı \"Otonom Yapay Zekâ Destekli Dijital Asistan\"; Erdem Yıldız ve Yusuf Yahya Demiraslan ile birlikte, Dr. Öğr. Üyesi Erdem Alkım danışmanlığında geliştirdik. Charon sesli komut alıyor, ekranın o anki durumunu analiz ediyor, tarayıcıda ve dosya sisteminde işlemleri kendisi yapıyor.",
        en: "Our graduation project in Computer Science at Dokuz Eylül University. The thesis is titled \"Autonomous AI-Assisted Digital Assistant\"; I built it with Erdem Yıldız and Yusuf Yahya Demiraslan, advised by Asst. Prof. Erdem Alkım. Charon takes voice commands, analyzes what's on the screen right now, and carries out tasks in the browser and the file system on its own.",
      },
      problem: {
        tr: "Sohbet eden asistanlar ne yapacağını söyler ama yapmaz. Ekranı göremedikleri ve makineye dokunamadıkları için, kullanıcının işi hâlâ tarif edileni elle uygulamaktır.",
        en: "Chat assistants tell you what to do but don't do it. Because they can't see the screen or touch the machine, the user still has to carry out the instructions by hand.",
      },
      solution: {
        tr: "Charon algı, karar ve eylemi tek döngüde birleştiriyor: ekran görüntüsünü ve webcam karesini analiz ediyor, konuşarak aldığı isteği yorumluyor, sonra klavye, fare, pencere odağı ve dosya işlemleriyle doğrudan uyguluyor. Tarayıcı işleri için Playwright entegrasyonu var; kod yazması gerektiğinde ayrı bir kod ajanı devreye giriyor.",
        en: "Charon closes the loop between perception, decision and action: it analyzes a screenshot and a webcam frame, interprets the spoken request, then carries it out directly through keystrokes, mouse operations, window focus and file operations. Playwright handles browser work, and a separate code agent steps in when code needs writing.",
      },
      highlights: [
        {
          title: { tr: "Hibrit mimari: yerel ve bulut", en: "Hybrid architecture: local and cloud" },
          body: {
            tr: "Charon hem çevrimdışı yerel yöntemlerle (yerel OCR, regex tabanlı doğal dil işleme, Windows UI Automation, yerel LLM'ler) hem de Gemini'nin çok modlu Live ve Vision API'leriyle çalışabiliyor. Tezde iki yaklaşımı, otonom asistanlar için standart test ortamı olan Windows Agent Arena (WAA) üzerinde karşılaştırdık. Sonuca göre hibrit entegrasyon görev başarısını belirgin şekilde artırıyor, görsel doğrulama döngüleri hataları azaltıyor; yerel sistem ise veri gizliliği ve gecikmesiz çalışma sağlıyor.",
            en: "Charon runs both on offline local methods (local OCR, regex-based language processing, Windows UI Automation, local LLMs) and on Gemini's multimodal Live and Vision APIs. In the thesis we compared the two on Windows Agent Arena (WAA), the standard benchmark for autonomous agents. Hybrid integration raised the task success rate significantly and visual verification loops cut errors, while the local system kept data private with near-zero latency.",
          },
        },
        {
          title: { tr: "Ekip çalışması", en: "Working as a team" },
          body: {
            tr: "Charon üç kişilik bir ekip işi ve danışman hocamızın yönlendirmesiyle ilerledi. Bu projede kod yazmak kadar, işi paylaşmak ve farklı elden çıkan parçaları ortak bir mimaride buluşturmak da önemliydi.",
            en: "Charon was a three-person team effort guided by our advisor. Splitting the work and bringing pieces built by different hands together in one architecture mattered as much as writing the code.",
          },
        },
        {
          title: { tr: "Konuşmadan konuşmaya", en: "Speech to speech" },
          body: {
            tr: "Gemini 2.5 Live modelleriyle düşük gecikmeli sesli etkileşim. Yazmadan, doğrudan konuşarak iş tarif ediliyor.",
            en: "Low-latency voice interaction with Gemini 2.5 Live models. You describe the task by speaking, not typing.",
          },
        },
        {
          title: { tr: "Ekranı ve kamerayı görüyor", en: "It sees the screen and camera" },
          body: {
            tr: "Yerel ekran görüntüsü ve webcam karesi yakalanıp doğrudan modelin görü yeteneğiyle analiz ediliyor. Asistan neye baktığını biliyor.",
            en: "Local screenshots and webcam frames are captured and analyzed through the model's vision capability. The assistant knows what it's looking at.",
          },
        },
        {
          title: { tr: "Masaüstü ve tarayıcı otomasyonu", en: "Desktop and browser automation" },
          body: {
            tr: "Klavye, fare, pencere odağı ve dosya işlemleri simüle ediliyor; tarayıcı tarafında Playwright ile arama, tıklama, yazma ve veri çıkarma yapılıyor.",
            en: "It simulates keystrokes, mouse operations, window focus and file operations, and uses Playwright in the browser to search, click, type and extract data.",
          },
        },
        {
          title: { tr: "Kalıcı yerel hafıza", en: "Persistent local memory" },
          body: {
            tr: "Tercihleri, aktif projeleri ve notları hatırlayan yerel bir hafıza sistemi var. Her oturum sıfırdan başlamıyor.",
            en: "A local memory system tracks preferences, active projects and notes, so each session doesn't start from zero.",
          },
        },
        {
          title: { tr: "Canlı sistem metrikleri", en: "Live system metrics" },
          body: {
            tr: "PyQt6 panelinde CPU, RAM, GPU ve ağ kullanımı gerçek zamanlı izleniyor; Steam ve Epic Games istemcileriyle entegre bir oyun merkezi de var.",
            en: "The PyQt6 dashboard monitors CPU, memory, GPU and network in real time, and a game hub integrates with the local Steam and Epic Games clients.",
          },
        },
      ],
      outcome: {
        tr: "Proje Haziran 2026'da bitirme tezi olarak teslim edildi ve bölüm sitesinde yayımlandı. Kod GitHub'da açık kaynak. Sesli komut ve ekran okuma özellikleri sayesinde görme ve hareket engelli kullanıcılar için erişilebilirlik potansiyeli de taşıyor.",
        en: "The project was submitted as our graduation thesis in June 2026 and published on the department's website. The code is open source on GitHub. Thanks to voice commands and screen reading, it also has real accessibility potential for users with visual or motor impairments.",
      },
    },
  },

  /* ============================================================ PINTOS */
  {
    slug: "pintos",
    tier: "featured",
    cover: "/media/pintos/cover.jpg",
    name: { tr: "Pintos Çekirdek Revizyonu", en: "Pintos Kernel Revision" },
    year: "2024",
    org: { tr: "Akademik", en: "Academic" },
    kind: { tr: "İşletim sistemi · C", en: "Operating systems · C" },
    status: { tr: "Tamamlandı", en: "Completed" },
    tagline: {
      tr: "Stanford'un eğitim amaçlı işletim sistemi Pintos'un çekirdeğinde, sistem çağrısı katmanını C ile yeniden yapılandırdım.",
      en: "I restructured the system call layer inside the kernel of Pintos, Stanford's teaching operating system, in C.",
    },
    gallery: [],
    metrics: [],
    stack: ["C", "x86", "System calls", "GDB", "Makefile"],
    links: [],
    detail: {
      overview: {
        tr: "Pintos, Stanford'un işletim sistemi derslerinde kullanılan, x86 üzerinde çalışan küçük ama gerçek bir çekirdek. Bu projede çekirdeğin sistem çağrısı katmanını yeniden yapılandırdım, çekirdeği derleyip test paketleriyle doğruladım.",
        en: "Pintos is a small but real x86 kernel used in Stanford's operating systems courses. In this project I restructured the kernel's system call layer, rebuilt the kernel and verified it against the test suites.",
      },
      problem: {
        tr: "Çekirdekte hata payı yok. Kullanıcı programından gelen tek bir geçersiz işaretçi ya da yanlış bir bellek erişimi bütün sistemi durdurabiliyor, üstelik alışılmış hata ayıklama araçlarının çoğu burada işe yaramıyor.",
        en: "There's no margin for error in a kernel. A single invalid pointer from a user program or one wrong memory access can bring the whole system down, and most of the usual debugging tools don't help here.",
      },
      solution: {
        tr: "Kullanıcı programı ile çekirdek arasındaki geçişi baştan ele aldım: sistem çağrısı argümanlarının çekirdeğe güvenli biçimde alınmasını, geçersiz isteklerin sistemi çökertmeden reddedilmesini ve her çağrının doğru işleyiciye yönlendirilmesini yeniden kurdum. Değişiklikleri GDB ile adım adım izleyip test paketleriyle doğruladım.",
        en: "I reworked the transition between user programs and the kernel: how system call arguments are brought into the kernel safely, how invalid requests are rejected without crashing the system, and how each call is routed to the right handler. I traced the changes step by step in GDB and verified them against the test suites.",
      },
      highlights: [
        {
          title: { tr: "Neden önemli", en: "Why it matters" },
          body: {
            tr: "Üst seviyede yazdığım her şeyin, bir dosya açmaktan ağ isteğine kadar, altında bu katman var. Bir sistem çağrısının gerçekte ne kadar iş yaptığını ve kullanıcı alanı ile çekirdek arasındaki sınırın nasıl korunduğunu burada birebir gördüm. Performans ve güvenlik sorunlarına bakışım büyük ölçüde bu projeden geliyor.",
            en: "Everything I write at a higher level, from opening a file to making a network request, sits on top of this layer. Here I saw first-hand how much work a system call really does and how the boundary between user space and the kernel is defended. Much of how I think about performance and security comes from this project.",
          },
        },
      ],
    },
  },

  /* ========================================================= CHATFOLIO */
  {
    slug: "chatfolio",
    tier: "other",
    name: "Chatfolio",
    year: "2026",
    org: { tr: "Açık kaynak", en: "Open source" },
    kind: { tr: "Bu sitenin motoru", en: "The engine behind this site" },
    status: { tr: "Yayında", en: "Live" },
    live: true,
    tagline: {
      tr: "Bu sitedeki \"Onur'a sor\" asistanı. Deneyimim ve projelerimle ilgili soruları benim adıma, sorulan dilde yanıtlıyor.",
      en: "The \"Ask Onur\" assistant on this site. It answers questions about my experience and projects on my behalf, in whatever language you ask.",
    },
    gallery: [
      {
        src: `${GH}/Chatfolio/main/preview_desktop.png`,
        caption: { tr: "Chatfolio arayüzü", en: "Chatfolio interface" },
      },
    ],
    metrics: [
      { value: "2", label: { tr: "dil: Türkçe ve İngilizce", en: "languages: Turkish and English" } },
    ],
    stack: ["React", "FastAPI", "LLM entegrasyonu", "Telegram Bot API", "Render"],
    links: [{ label: "GitHub", href: "https://github.com/Tetherium/Chatfolio" }],
    detail: {
      overview: {
        tr: "İşverenlerin ve ziyaretçilerin deneyimim, yeteneklerim ve projelerim hakkında doğrudan soru sorabildiği bir yapay zekâ asistanı. Şu an okuduğun sitenin soru-cevap kısmı bu sistemle çalışıyor.",
        en: "An AI assistant that lets employers and visitors ask directly about my experience, skills and projects. The Q&A on the site you're reading runs on it.",
      },
      problem: {
        tr: "CV statik bir belge: okuyanın aklına takılan spesifik soruya cevap veremez. \"Bu ölçekte bir scraper altyapısını nasıl kurdun?\" sorusunun cevabı hiçbir CV'ye sığmaz.",
        en: "A CV is a static document: it can't answer the specific question that occurs to the reader. \"How did you build a scraper at that scale?\" doesn't fit on any CV.",
      },
      solution: {
        tr: "FastAPI backend'i, özgeçmişimin tamamını bağlam olarak taşıyan bir dil modeline bağlıyor; soru hangi dilde sorulursa cevap o dilde dönüyor. Her sorgu, IP'den çözümlenen konum ve yanıt süresiyle birlikte Telegram botuma düşüyor — yani siteye kimin geldiğini ve neyi merak ettiğini anlık görüyorum.",
        en: "A FastAPI backend connects a language model that carries my full CV as context, and answers come back in whichever language the question was asked. Every query lands in my Telegram bot along with the location resolved from the IP and the response time — so I see who visits and what they're curious about, live.",
      },
      highlights: [
        {
          title: { tr: "Telegram loglaması", en: "Telegram logging" },
          body: {
            tr: "Her soru, konum, cihaz ve yanıt süresiyle birlikte anlık olarak telefonuma düşüyor. Sitenin ziyaretçi analitiği aslında bu.",
            en: "Every question reaches my phone instantly with location, device and response time. This is effectively the site's visitor analytics.",
          },
        },
        {
          title: { tr: "Dil eşleştirme", en: "Language matching" },
          body: {
            tr: "Arayüz dili ne olursa olsun, cevap kullanıcının yazdığı mesajın dilinde veriliyor. İngilizce soran İngilizce cevap alıyor.",
            en: "Whatever the interface language, the reply comes back in the language the user wrote in. Ask in English, get English.",
          },
        },
        {
          title: { tr: "Komut paletine gömülü", en: "Built into the command palette" },
          body: {
            tr: "Bu sitede Chatfolio ayrı bir sohbet sayfası değil; ⌘K komut paletinin içinde yaşıyor. Aramaya başlayan biri kendini soru sorarken buluyor.",
            en: "On this site Chatfolio isn't a separate chat page; it lives inside the ⌘K command palette. Someone who starts searching finds themselves asking a question.",
          },
        },
      ],
      outcome: {
        tr: "Sistem onurcinkaya.cv üzerinde yayında ve açık kaynak.",
        en: "The system is live on onurcinkaya.cv and open source.",
      },
    },
  },

  /* ========================================================= GITDRAGON */
  {
    slug: "gitdragon",
    tier: "other",
    name: "GitDragon",
    year: "2026",
    org: { tr: "Açık kaynak", en: "Open source" },
    kind: { tr: "GitHub widget'ı", en: "GitHub widget" },
    status: { tr: "Yayında", en: "Live" },
    live: true,
    tagline: {
      tr: "GitHub profilinde yaşayan 16-bit bir ejderha. Commit attıkça büyüyor, ara verince acıkıyor; kurulum gerektirmiyor.",
      en: "A 16-bit dragon that lives on your GitHub profile. It grows as you commit and gets hungry when you stop; no setup needed.",
    },
    gallery: [
      { src: `${GH}/GitDragon/main/public/egg.png`, caption: { tr: "Yumurta · 0-2 gün", en: "Egg · 0-2 days" } },
      { src: `${GH}/GitDragon/main/public/baby.png`, caption: { tr: "Bebek · 3-7 gün", en: "Baby · 3-7 days" } },
      {
        src: `${GH}/GitDragon/main/public/legendary.png`,
        caption: { tr: "Efsanevi · 21+ gün", en: "Legendary · 21+ days" },
      },
    ],
    metrics: [
      { value: "6", label: { tr: "evrim aşaması", en: "evolution stages" } },
      { value: "0", label: { tr: "kurulum adımı", en: "setup steps" } },
    ],
    stack: ["JavaScript", "Next.js", "Serverless API", "Vercel", "Pixel art"],
    links: [
      { label: "git-dragon.vercel.app", href: "https://git-dragon.vercel.app" },
      { label: "GitHub", href: "https://github.com/Tetherium/GitDragon" },
    ],
    detail: {
      overview: {
        tr: "GitHub profil README'nde yaşayan, commit serine göre evrimleşen retro piksel sanatı bir Tamagotchi. Kurulum, script veya cron gerektirmiyor: tek bir Markdown satırı yapıştırıyorsun, gerisi kendiliğinden işliyor.",
        en: "A retro pixel-art Tamagotchi that lives in your GitHub profile README and evolves with your commit streak. No install, no scripts, no cron: you paste one line of Markdown and the rest runs itself.",
      },
      problem: {
        tr: "GitHub profil README'leri statik rozetlerle dolu. Hiçbiri, insanı yarın da kod yazmaya iten bir şey sunmuyor.",
        en: "GitHub profile READMEs are full of static badges. None of them give you a reason to write code again tomorrow.",
      },
      solution: {
        tr: "Sunucusuz bir API, kullanıcının katkı grafiğini istendiği anda okuyup ejderhanın güncel halini bir görsel olarak üretiyor. README'deki tek satır bu API'yi çağırdığı için, profil sayfası her açıldığında ejderha güncel: commit atılmışsa büyümüş, atılmamışsa acıkmış.",
        en: "A serverless API reads the user's contribution graph on request and renders the dragon's current state as an image. Because the single README line calls that API, the dragon is current every time the profile loads — grown if you committed, hungry if you didn't.",
      },
      highlights: [
        {
          title: { tr: "Altı aşamalı evrim", en: "Six evolution stages" },
          body: {
            tr: "Yumurta (0-2 gün), bebek (3-7), ergen (8-20), efsanevi (21+). 48 saat commit atmazsan üzülüyor, 5 gün atmazsan hayalete dönüşüyor — ve bir commit'le geri geliyor.",
            en: "Egg (0-2 days), baby (3-7), teenager (8-20), legendary (21+). Skip 48 hours and it gets sad; skip five days and it turns into a ghost — revived by a single commit.",
          },
        },
        {
          title: { tr: "Yapıştır ve unut", en: "Paste once, run forever" },
          body: {
            tr: "GitHub Actions, cron job veya yerel script yok. Kullanıcı sitede adını yazıyor, çıkan Markdown satırını README'sine yapıştırıyor, bitti.",
            en: "No GitHub Actions, no cron jobs, no local scripts. The user types their name on the site, pastes the Markdown snippet into their README, and that's it.",
          },
        },
        {
          title: { tr: "Elle çizilmiş sprite'lar", en: "Hand-drawn sprites" },
          body: {
            tr: "Her aşamanın 16-bit piksel sanatı sprite'ı ayrı çizildi. Görsel kimlik tarafını da kendim yaptım.",
            en: "Each stage has its own 16-bit pixel-art sprite. I did the visual identity side as well.",
          },
        },
      ],
      outcome: {
        tr: "Proje Vercel'de yayında ve GitHub'da açık kaynak.",
        en: "The project is live on Vercel and open source on GitHub.",
      },
    },
  },

  /* ============================================= AUTOMATED EMAIL SENDER */
  {
    slug: "automated-email-sender",
    tier: "other",
    name: { tr: "Güvenli Toplu Mail Gönderici", en: "Safe Bulk Mailer" },
    year: "2026",
    org: { tr: "Açık kaynak", en: "Open source" },
    kind: { tr: "SMTP otomasyonu", en: "SMTP automation" },
    status: { tr: "GitHub'da", en: "On GitHub" },
    tagline: {
      tr: "Excel listesinden kişiselleştirilmiş toplu e-posta gönderen, spam filtresine takılmamak için gönderim hızını ayarlayan Python aracı.",
      en: "A Python tool that sends personalized bulk email from an Excel list and paces itself to stay out of spam filters.",
    },
    gallery: [],
    metrics: [
      { value: "45-90 sn", label: { tr: "mailler arası rastgele bekleme", en: "randomized delay between emails" } },
      { value: "10 / 5 dk", label: { tr: "mailde bir soğuma", en: "emails, then a cooldown" } },
    ],
    stack: ["Python", "SMTP", "SSL / STARTTLS", "openpyxl", "HTML mail"],
    links: [{ label: "GitHub", href: "https://github.com/Tetherium/automated-email-sender" }],
    detail: {
      overview: {
        tr: "Excel veritabanından kişiselleştirilmiş toplu mail gönderen, ama bunu spam filtresine yakalanmadan yapmaya çalışan bir SMTP aracı.",
        en: "An SMTP tool that sends personalized bulk email from an Excel database — while trying not to get caught by spam filters.",
      },
      problem: {
        tr: "Toplu mail gönderen basit scriptler hızlı davranır ve gönderen adresi kısa sürede kara listeye düşer. Asıl problem mail göndermek değil, gönderebilmeye devam edebilmek.",
        en: "Simple bulk mailers move fast and get the sending address blacklisted quickly. The real problem isn't sending mail; it's still being able to send it tomorrow.",
      },
      solution: {
        tr: "Araç mailler arasına 45-90 saniyelik rastgele beklemeler koyuyor ve her 10 mailde bir 5 dakika duruyor. Alıcı listesi ve mesaj içeriği doğrudan .xlsx dosyasından okunuyor; tek hücrede noktalı virgül veya virgülle ayrılmış çoklu alıcı destekleniyor.",
        en: "It inserts randomized 45-90 second waits between messages and pauses for five minutes after every ten. Recipients and message bodies are read straight from an .xlsx file, with support for multiple addresses in a single cell separated by semicolons or commas.",
      },
      highlights: [
        {
          title: { tr: "İki protokol", en: "Two protocols" },
          body: {
            tr: "Hem SSL (port 465) hem STARTTLS (port 587) destekleniyor; sağlayıcı fark etmeksizin çalışıyor.",
            en: "Both SSL (port 465) and STARTTLS (port 587) are supported, so it works regardless of provider.",
          },
        },
        {
          title: { tr: "HTML imza desteği", en: "HTML signatures" },
          body: {
            tr: "Düz metin değil, profesyonel imzalı zengin metin mailler gönderilebiliyor.",
            en: "It sends rich-text mail with proper signatures rather than plain text.",
          },
        },
      ],
    },
  },

  /* ================================================ IMAP SETTINGS SCRAPER */
  {
    slug: "imap-settings-scraper",
    tier: "other",
    name: { tr: "IMAP Ayar Keşfi", en: "IMAP Settings Scraper" },
    year: "2026",
    org: { tr: "Açık kaynak", en: "Open source" },
    kind: { tr: "Selenium otomasyonu", en: "Selenium automation" },
    status: { tr: "GitHub'da", en: "On GitHub" },
    tagline: {
      tr: "Bir alan adı listesi için IMAP sunucu ve port ayarlarını otomatik bulan Python aracı.",
      en: "A Python tool that finds IMAP server and port settings for a list of domains automatically.",
    },
    gallery: [],
    metrics: [],
    stack: ["Python", "Selenium", "Chrome WebDriver"],
    links: [{ label: "GitHub", href: "https://github.com/Tetherium/imap-settings-scraper" }],
    detail: {
      overview: {
        tr: "Bir alan adı listesi verip karşılığında IMAP sunucu adreslerini ve port numaralarını alabildiğin toplu keşif aracı.",
        en: "A batch discovery tool: hand it a list of domains, get back IMAP server addresses and port numbers.",
      },
      problem: {
        tr: "Mail otomasyonu kuran biri için her alan adının IMAP ayarını elle bulmak saatler süren, tamamen mekanik bir iş.",
        en: "For anyone building mail automation, looking up each domain's IMAP settings by hand is hours of purely mechanical work.",
      },
      solution: {
        tr: "Selenium, imapsettings.com arayüzünü otomatik sürüyor; sonuçlar doğrudan Python sözlüğüne yapıştırılabilecek formatta yazılıyor. Bilgi bulunamadığında kayıt \"none\" olarak işaretleniyor, böylece çıktı her zaman ayrıştırılabilir kalıyor.",
        en: "Selenium drives the imapsettings.com interface automatically, and results are written in a format you can paste straight into a Python dictionary. When nothing is found the record is marked \"none\", so the output always stays parseable.",
      },
      highlights: [],
    },
  },

  /* ============================================ LINKEDIN EMPLOYEE SCRAPER */
  {
    slug: "linkedin-employee-scraper",
    tier: "other",
    name: { tr: "LinkedIn Çalışan Sayısı Çıkarımı", en: "LinkedIn Employee Scraper" },
    year: "2026",
    org: { tr: "Açık kaynak", en: "Open source" },
    kind: { tr: "Veri toplama", en: "Data collection" },
    status: { tr: "GitHub'da", en: "On GitHub" },
    tagline: {
      tr: "LinkedIn şirket sayfalarından çalışan sayılarını toplayıp sıralanabilir bir Excel tablosuna çeviren otomasyon.",
      en: "Automation that collects employee counts from LinkedIn company pages into a sortable spreadsheet.",
    },
    gallery: [],
    metrics: [],
    stack: ["Python", "Selenium", "openpyxl"],
    links: [{ label: "GitHub", href: "https://github.com/Tetherium/linkedin-employee-scraper" }],
    detail: {
      overview: {
        tr: "Bir Excel dosyasındaki LinkedIn şirket bağlantılarını gezip çalışan sayısı bilgisini toplayan ve normalize edilmiş halde geri yazan araç.",
        en: "A tool that walks the LinkedIn company links in a spreadsheet, collects employee counts and writes them back normalized.",
      },
      problem: {
        tr: "Şirket büyüklüğü verisi hem dağınık hem de tutarsız biçimde yazılıyor: \"501-1,000 employees\", \"1K+\", \"11-50\". Bu haliyle sıralanamıyor, filtrelenemiyor.",
        en: "Company size data is scattered and inconsistently written: \"501-1,000 employees\", \"1K+\", \"11-50\". In that state it can't be sorted or filtered.",
      },
      solution: {
        tr: "Araç girdi Excel'indeki URL sütununu kendisi tespit ediyor, ham metni normalleştiriyor (\"501-1,000 employees\" → \"501+\") ve her URL için başarı / bulunamadı / hata durumunu kaydediyor. Böylece yarım kalan bir tarama kaldığı yerden sürdürülebiliyor.",
        en: "It detects the URL column in the input spreadsheet itself, normalizes the raw strings (\"501-1,000 employees\" → \"501+\"), and logs success / not found / error for every URL, so an interrupted run can be resumed.",
      },
      highlights: [],
    },
  },

  /* ============================================================ IMMETA */
  {
    slug: "zigzag-together",
    tier: "other",
    name: "Zigzag Together",
    year: "2026",
    org: "Immeta Studio",
    kind: { tr: "Online co-op altyapısı", en: "Online co-op infrastructure" },
    status: { tr: "Staj projesi", en: "Internship project" },
    tagline: {
      tr: "Stajımda, yayındaki tek oyunculu bir oyuna katılım kodlu online co-op modu ekledim.",
      en: "During my internship I added online co-op with join-code rooms to a shipped single-player game.",
    },
    gallery: [],
    metrics: [
      { value: "2", label: { tr: "ayrı ağda test edildi", en: "separate networks tested" } },
    ],
    stack: ["Unity", "Netcode for GameObjects", "Relay", "Lobby", "C#"],
    links: [],
    detail: {
      overview: {
        tr: "Immeta Studio'daki stajım sırasında, yayınlanmış tek oyunculu Zigzag Together oyununa online çok oyunculu altyapı kurdum.",
        en: "During my internship at Immeta Studio I built online multiplayer infrastructure for the shipped single-player game Zigzag Together.",
      },
      problem: {
        tr: "Oyun tek oyuncu için tasarlanmıştı. Çok oyunculuya geçmek yalnızca ağ kodu eklemek değil, oyun durumunun kimde olduğunu baştan tanımlamak demekti.",
        en: "The game was designed for a single player. Going multiplayer wasn't just adding network code; it meant redefining who owns the game state.",
      },
      solution: {
        tr: "Unity Netcode for GameObjects ile durum senkronizasyonunu, Relay ile NAT arkasındaki oyuncular arası bağlantıyı, Lobby ile de katılım kodlu oda sistemini kurdum. Sistemi birbirinden bağımsız iki ağda test ederek gerçek koşullarda doğruladım.",
        en: "I used Unity Netcode for GameObjects for state synchronization, Relay to connect players behind NAT, and Lobby for the join-code room system, then validated it under real conditions across two independent networks.",
      },
      highlights: [],
    },
  },
  {
    slug: "life-and-shadow",
    tier: "other",
    name: "Life & Shadow: Celestial Call",
    year: "2026",
    org: "Immeta Studio",
    kind: { tr: "Yayın öncesi veri analizi", en: "Pre-launch data analysis" },
    status: { tr: "Staj projesi", en: "Internship project" },
    tagline: {
      tr: "Stajımda bir Steam oyununun yayın öncesi verilerini analiz edip mağaza sayfası ve pazarlama önerilerine çevirdim.",
      en: "During my internship I analyzed a Steam game's pre-launch data and turned it into store page and marketing recommendations.",
    },
    gallery: [],
    metrics: [
      { value: "4.900+", label: { tr: "istek listesi analiz edildi", en: "wishlists analyzed" } },
      { value: "%29,7", label: { tr: "Prologue dönüşüm oranı", en: "Prologue conversion rate" } },
      { value: "260+", label: { tr: "içerik üreticisi önceliklendirildi", en: "creators prioritized" } },
    ],
    stack: ["Steamworks", "Veri analizi", "A/B testli mail kampanyası", "Meshy AI", "Blender"],
    links: [],
    detail: {
      overview: {
        tr: "Bir Steam oyununun yayın öncesi verilerini analiz edip mağaza sayfası önerileri ve pazarlama planı hazırladım.",
        en: "I analyzed a Steam game's pre-launch data and produced store page recommendations and a marketing plan.",
      },
      problem: {
        tr: "Yayın öncesinde elde çok veri vardı ama karar yoktu: hangi kitleye, hangi mesajla, hangi kanaldan gidilecekti?",
        en: "Before launch there was plenty of data but no decision: which audience, which message, which channel?",
      },
      solution: {
        tr: "Steamworks verilerini (istek listesi hacmi, Prologue'dan ana oyuna dönüşüm) analiz edip yayın öncesi rapora çevirdim. 260'tan fazla içerik üreticisini erişim ve uyum kriterlerine göre önceliklendiren bir veri havuzu kurdum; A/B testli mail kampanyasını ve Reddit içerik takvimini yürüttüm. Ayrıca Meshy AI + Blender ile Unity'ye hazır 3B model üretim hattını kurdum.",
        en: "I turned Steamworks data — wishlist volume, Prologue-to-full-game conversion — into a pre-launch report. I built a pool that prioritized 260+ content creators by reach and fit, and ran the A/B-tested email campaign and Reddit content calendar. I also set up a Meshy AI + Blender pipeline for Unity-ready 3D models.",
      },
      highlights: [],
    },
  },

  /* ============================================================== MEZZ */
  {
    slug: "fuzzy-lead-scoring",
    tier: "other",
    name: { tr: "Bulanık Mantıkla Müşteri Skorlama", en: "Fuzzy Logic Lead Scoring" },
    year: "2025",
    org: "Mezz Solution",
    kind: { tr: "Müşteri projesi · veri analizi", en: "Client project · data analysis" },
    status: { tr: "Teslim edildi", en: "Delivered" },
    tagline: {
      tr: "Satış ekibinin sözel müşteri kriterlerini bulanık mantıkla puana çeviren sistem. Haftalar süren manuel veri incelemesini %80 kısalttı.",
      en: "A system that turns a sales team's verbal lead criteria into scores with fuzzy logic. It cut weeks of manual data review by 80%.",
    },
    gallery: [],
    metrics: [{ value: "%80", label: { tr: "daha hızlı inceleme", en: "faster review" } }],
    stack: ["Python", "Fuzzy Logic", "Excel otomasyonu", "Veri temizleme"],
    links: [],
    detail: {
      overview: {
        tr: "Shenzhen merkezli Mezz Solution için uzaktan, proje bazlı çalıştım. Satış ekibinin müşteri seçerken kullandığı kriterleri onlarla birlikte netleştirip büyük veri setlerinden potansiyel müşteri belirleyen bir skorlama sistemine çevirdim.",
        en: "I worked remotely, on a project basis, for Shenzhen-based Mezz Solution. I clarified with the sales team the criteria they used to pick leads, then turned them into a scoring system that surfaces potential customers from large datasets.",
      },
      problem: {
        tr: "Satış ekibi binlerce şirket kaydını elle eliyordu. Kriterler net sayılar değil, \"büyükçe\", \"bizim sektöre yakın\", \"aktif görünüyor\" gibi sözel yargılardı — yani doğrudan koda dökülemiyordu.",
        en: "The sales team filtered thousands of company records by hand. The criteria weren't clean numbers but verbal judgments — \"fairly large\", \"close to our sector\", \"looks active\" — which don't translate directly into code.",
      },
      solution: {
        tr: "Bulanık mantık tam olarak bu boşluk için var. Sözel kriterleri üyelik fonksiyonlarına çevirip her şirket için tek bir uygunluk puanı üreten algoritmalar yazdım. Python ve Excel dokümantasyon otomasyonlarıyla süreci uçtan uca bağladım.",
        en: "Fuzzy logic exists for exactly this gap. I turned the verbal criteria into membership functions and wrote algorithms that produce a single fit score per company, then wired the process end to end with Python and Excel automation.",
      },
      highlights: [],
    },
  },

  /* ======================================================== CHRONOTYPE */
  {
    slug: "chronotype",
    tier: "other",
    name: "ChronoType",
    year: "2026",
    org: { tr: "Açık kaynak", en: "Open source" },
    kind: { tr: "Yerel analitik motoru", en: "Local analytics engine" },
    status: { tr: "GitHub'da açık kaynak", en: "Open source on GitHub" },
    live: true,
    tagline: {
      tr: "Yazma alışkanlıklarını analiz eden, hiçbir veriyi bilgisayarın dışına göndermeyen C++ Windows uygulaması.",
      en: "A C++ Windows app that analyzes your typing habits and never sends any data off your computer.",
    },
    gallery: [
      {
        src: "/media/chronotype/01.png",
        ratio: "16 / 10",
        caption: { tr: "Panel", en: "Dashboard" },
      },
      {
        src: `${GH}/ChronoType/main/src/words.jpg`,
        caption: { tr: "En çok yazılan kelimeler", en: "Most typed words" },
      },
      { src: `${GH}/ChronoType/main/src/stats.jpg`, caption: { tr: "İstatistikler", en: "Statistics" } },
      {
        src: `${GH}/ChronoType/main/src/hidden.jpg`,
        caption: { tr: "Sistem tepsisi", en: "System tray" },
      },
    ],
    metrics: [
      { value: "%100", label: { tr: "çevrimdışı", en: "offline" } },
      { value: "0", label: { tr: "dış bağlantı, 0 telemetri", en: "outbound requests, 0 telemetry" } },
    ],
    stack: ["C++", "WIN32 API", "SQLite", "cpp-httplib", "Chart.js", "Windows Registry"],
    links: [{ label: "GitHub", href: "https://github.com/Tetherium/ChronoType" }],
    detail: {
      overview: {
        tr: "Native C++ ile yazılmış, Windows'ta arka planda sessizce çalışan bir tuş vuruşu analiz motoru. Yazma alışkanlıklarını görselleştiriyor; ama bunu mahremiyeti bozmadan yapıyor.",
        en: "A keystroke analytics engine written in native C++ that runs quietly in the background on Windows. It visualizes your typing habits without compromising privacy.",
      },
      problem: {
        tr: "Yazma istatistiklerini ölçen araçların neredeyse tamamı veriyi bir sunucuya gönderiyor. Tuş vuruşu, bir insanın ürettiği en hassas veri türlerinden biri; onu buluta yollayan bir araç güvenilmez.",
        en: "Almost every tool that measures typing statistics ships the data to a server. Keystrokes are among the most sensitive data a person produces; a tool that uploads them can't be trusted.",
      },
      solution: {
        tr: "ChronoType katı bir %100 çevrimdışı politikayla çalışıyor. Her tuş vuruşu makinenin içinde işlenip yerel bir SQLite veritabanına yazılıyor. Uygulama hiçbir dış bağlantı kurmuyor: API yok, telemetri yok, anonim metrik yok. Panel bile yalnızca makineye özel, dinamik olarak bağlanan bir localhost portunda açılıyor.",
        en: "ChronoType runs on a strict 100% offline policy. Every keystroke is processed inside the machine and written to a local SQLite database. The application makes no outbound connections: no APIs, no telemetry, no anonymous metrics. Even the dashboard is served only on a dynamically bound localhost port unique to that machine.",
      },
      highlights: [
        {
          title: { tr: "Gömülü C++ HTTP sunucusu", en: "Embedded C++ HTTP server" },
          body: {
            tr: "Panel, cpp-httplib ile uygulamanın içine gömülü bir ağ thread'i üzerinden servis ediliyor; arayüz tarafında Vanilla JavaScript ve Chart.js var. Ayrı bir sunucu kurmaya gerek yok.",
            en: "The dashboard is served from a networking thread embedded in the application with cpp-httplib, with Vanilla JavaScript and Chart.js on the front end. No separate server to install.",
          },
        },
        {
          title: { tr: "Türkçe karakterleri bozmayan ayrıştırma", en: "Parsing that survives Turkish" },
          body: {
            tr: "Çok baytlı UTF-8 karakterler (ğ, ü, ş, ö, ç, i) tampon bozulmadan doğal kelimelere ayrılıyor. Bu, tuş vuruşu seviyesinde çalışan bir araçta göründüğünden çok daha zor bir problem.",
            en: "Multi-byte UTF-8 characters (ğ, ü, ş, ö, ç, i) are assembled into natural words without buffer corruption — a much harder problem at the keystroke level than it looks.",
          },
        },
        {
          title: { tr: "Görünmez arka plan modu", en: "Invisible background mode" },
          body: {
            tr: "Uygulama kendini WIN32 arka plan uygulaması olarak yapılandırıyor: konsol penceresi açılmıyor. Kontrol, Windows sistem tepsisindeki hafif bir simgeden sağlanıyor.",
            en: "The app configures itself as a WIN32 background application, so no console window appears. Control lives in a lightweight Windows system tray icon.",
          },
        },
        {
          title: { tr: "Aç ve unut", en: "Launch and forget" },
          body: {
            tr: "Yerel bir kayıt defteri anahtarıyla bilgisayar açılışında kendiliğinden başlıyor ve ölçüme kaldığı yerden devam ediyor.",
            en: "A local registry key restarts it at boot so analytics resume where they left off.",
          },
        },
      ],
      outcome: {
        tr: "Proje GitHub'da açık kaynak; hazır sürüm Releases bölümünden indirilebiliyor.",
        en: "The project is open source on GitHub, with a ready-to-run build in the Releases section.",
      },
    },
  },

  /* =================================================== TELEGRAM DESKTOP */
  {
    slug: "telegram-desktop-fork",
    tier: "other",
    name: { tr: "Telegram Desktop Güvenlik Revizyonu", en: "Telegram Desktop Security Fork" },
    year: "2024",
    org: { tr: "Kişisel", en: "Personal" },
    kind: { tr: "Açık kaynak fork", en: "Open source fork" },
    status: { tr: "Tamamlandı", en: "Completed" },
    tagline: {
      tr: "Telegram'ın açık kaynak masaüstü istemcisine ek bir uçtan uca şifreleme katmanı ekleyip yeniden derledim.",
      en: "I added an extra end-to-end encryption layer to Telegram's open-source desktop client and rebuilt it.",
    },
    gallery: [],
    metrics: [],
    stack: ["C++", "Kriptografi", "CMake", "Build sistemleri"],
    links: [],
    detail: {
      overview: {
        tr: "Telegram'ın açık kaynaklı masaüstü uygulamasını fork'layıp mesaj iletim ve saklama süreçlerine ek uçtan uca şifreleme katmanları ekledim, uygulamayı yeniden derleyerek güvenliği artırılmış bir sürüm ürettim.",
        en: "I forked Telegram's open-source desktop application, added extra end-to-end encryption layers to its message transport and storage paths, and rebuilt it into a hardened version.",
      },
      problem: {
        tr: "Yüz binlerce satırlık, uzun süredir geliştirilen bir C++ kod tabanına dokunmak, önce onu okuyabilmeyi gerektiriyor. Mesajın hangi katmanda hangi biçimde bulunduğunu bulmak işin asıl zor kısmıydı.",
        en: "Touching a long-lived C++ codebase of hundreds of thousands of lines requires being able to read it first. Finding where a message exists, in what form, at which layer was the genuinely hard part.",
      },
      solution: {
        tr: "İletim ve saklama yollarını izleyip ek şifreleme katmanını doğru noktalara yerleştirdim, sonra projeyi baştan derleyip çalışır bir sürüm ürettim. Büyük ve yabancı bir kod tabanında gezinme becerim büyük ölçüde bu projede oturdu.",
        en: "I traced the transport and storage paths, placed the additional encryption layer at the right points, then rebuilt the project into a working binary. My ability to navigate a large, unfamiliar codebase largely settled here.",
      },
      highlights: [],
    },
  },

  /* ============================================================= EMLAK */
  {
    slug: "emlak-karar-destek",
    tier: "other",
    name: { tr: "Emlak Karar Destek Sistemi", en: "Real Estate Decision Support" },
    year: "2024",
    org: { tr: "Kişisel", en: "Personal" },
    kind: { tr: "Bulanık mantık", en: "Fuzzy logic" },
    status: { tr: "Tamamlandı", en: "Completed" },
    tagline: {
      tr: "\"Sakin ama merkeze yakın\" gibi sözel istekleri bulanık mantıkla puanlayıp en uygun evi öneren karar destek sistemi.",
      en: "A decision support system that scores verbal wishes like \"quiet but close to the center\" with fuzzy logic and suggests the best-fitting home.",
    },
    gallery: [],
    metrics: [],
    stack: ["Python", "Fuzzy Logic", "Veri modelleme"],
    links: [],
    detail: {
      overview: {
        tr: "Konum, fiyat, konfor ve güvenlik gibi kriterleri bulanık mantıkla puanlayıp kullanıcının tarifine en uygun evi bulan karar destek sistemi.",
        en: "A decision support system that scores criteria like location, price, comfort and safety with fuzzy logic to find the home that best fits a user's description.",
      },
      problem: {
        tr: "İnsanlar ev ararken sayı söylemez; \"çok pahalı olmasın\", \"sakin bir yer olsun\" der. Klasik filtreler bu isteği karşılayamaz çünkü her kriter keskin bir eşik ister.",
        en: "People don't speak in numbers when house hunting; they say \"not too expensive\", \"somewhere quiet\". Classic filters can't serve that, because each criterion demands a hard threshold.",
      },
      solution: {
        tr: "Her kriter için üyelik fonksiyonları tanımlayıp sözel ifadeleri 0-1 aralığına yaydım, sonra bunları ağırlıklandırıp tek bir uygunluk puanına indirdim. Sonuç, keskin filtrenin eleyeceği ama aslında çok uygun olan evleri de yakalıyor.",
        en: "I defined membership functions for each criterion, spread the verbal expressions across a 0-1 range, then weighted and reduced them to a single fit score. The result also catches homes a hard filter would discard although they fit well.",
      },
      highlights: [],
    },
  },

  /* ==================================================== ENGELSIZ SAMU */
  {
    slug: "engelsiz-samu",
    tier: "other",
    name: "Engelsiz SAMÜ",
    year: "2023",
    org: { tr: "Samsun Üniversitesi", en: "Samsun University" },
    kind: { tr: "Erişilebilirlik", en: "Accessibility" },
    status: { tr: "Kurul tarafından kabul edildi", en: "Accepted by the board" },
    tagline: {
      tr: "Üniversite sitesini engelli kullanıcılar için erişilebilir kılmak üzerine hazırladığım, kurul tarafından kabul edilen proje.",
      en: "A proposal to make the university website accessible to disabled users, accepted by the university board.",
    },
    gallery: [],
    metrics: [],
    stack: ["WCAG", "Frontend", "Erişilebilirlik testleri"],
    links: [],
    detail: {
      overview: {
        tr: "Samsun Üniversitesi için engelli bireylerin siteyi gerçekten kullanabilmesini hedefleyen bir web erişilebilirliği projesi hazırladım; proje üniversite kurulu tarafından kabul edildi.",
        en: "I prepared a web accessibility project for Samsun University aimed at letting disabled users genuinely use the site; the board accepted it.",
      },
      problem: {
        tr: "Erişilebilirlik çoğu projede en sona bırakılan ve genelde hiç yapılmayan iş. Ekran okuyucuyla gezilemeyen bir üniversite sitesi, bazı öğrenciler için hiç var olmayan bir site demek.",
        en: "Accessibility is the task most projects leave for last and usually never do. A university site you can't navigate with a screen reader is, for some students, a site that doesn't exist.",
      },
      solution: {
        tr: "Klavye navigasyonu, anlamlı doküman yapısı, yeterli renk kontrastı ve ekran okuyucu uyumu üzerine kurulu bir revizyon planı hazırladım.",
        en: "I produced a revision plan built on keyboard navigation, meaningful document structure, sufficient color contrast and screen reader compatibility.",
      },
      highlights: [],
    },
  },

  /* ======================================================= AKILLI DOLAP */
  {
    slug: "akilli-dolap",
    tier: "other",
    name: { tr: "Akıllı Dolap", en: "Smart Cabinet" },
    year: "2023",
    org: { tr: "Kişisel", en: "Personal" },
    kind: { tr: "Gömülü sistem", en: "Embedded system" },
    status: { tr: "Tamamlandı", en: "Completed" },
    tagline: {
      tr: "ESP32 ve mantık kapılarıyla kurduğum, kapağı açılınca müzik çalan akıllı dolap kilidi.",
      en: "A smart cabinet lock built from an ESP32 and logic gates that plays music when the door opens.",
    },
    gallery: [],
    metrics: [],
    stack: ["ESP32", "C", "Mantık kapıları", "Wi-Fi", "SD kart"],
    links: [],
    detail: {
      overview: {
        tr: "ESP32 kullanarak mantık kapılarıyla fiziksel bir anahtar mekanizması tasarladım; uzaktan Wi-Fi veya SD kart üzerinden müzik yüklenebiliyor ve kapak açıldığında ses sistemi tetikleniyor.",
        en: "Using an ESP32 I designed a physical latch from logic gates; music can be uploaded over Wi-Fi or SD card, and opening the door triggers the sound system.",
      },
      problem: {
        tr: "Yazılımın fiziksel dünyaya dokunduğu yerde hata payı yok: bir röle ya çeker ya çekmez, bir kapı ya açılır ya açılmaz.",
        en: "Where software touches the physical world there's no margin: a relay either fires or it doesn't, a door either opens or it doesn't.",
      },
      solution: {
        tr: "Mantık kapılarını doğrudan kullanarak mekanizmayı donanım seviyesinde kurdum, ESP32 tarafında Wi-Fi üzerinden dosya aktarımını ve kapak sensörüyle tetiklenen ses çalmayı yazdım. Sayısal tasarım dersinde öğrendiğim şeyin masadan çıkıp bir dolabın içinde çalıştığını görmek projenin asıl kazanımıydı.",
        en: "I built the mechanism at hardware level using logic gates directly, and on the ESP32 side wrote file transfer over Wi-Fi and door-sensor-triggered playback. Watching what I'd learned in digital design leave the desk and work inside a cabinet was the real takeaway.",
      },
      highlights: [],
    },
  },

  /* ======================================================== FREELANCE */
  {
    slug: "isletme-web-randevu",
    tier: "other",
    name: { tr: "İşletme Siteleri ve Randevu Sistemleri", en: "Business Sites and Booking Systems" },
    year: "2019+",
    org: { tr: "Bağımsız çalışma", en: "Independent work" },
    kind: { tr: "Müşteri projeleri · web", en: "Client projects · web" },
    status: { tr: "Devam ediyor", en: "Ongoing" },
    tagline: {
      tr: "Berber, kuaför ve güzellik merkezleri için web sitesi ve online randevu sistemi. Her işletmeyle ihtiyacını birebir konuşarak çalışıyorum.",
      en: "Websites and online booking for barbers, salons and beauty centers. I work through each business's needs with them one-on-one.",
    },
    gallery: [],
    metrics: [],
    stack: ["Next.js", "React", "Vercel", "VPS", "PostgreSQL"],
    links: [],
    detail: {
      overview: {
        tr: "2019'dan beri küçük işletmeler için Next.js/React siteleri geliştirip VPS ve Vercel'de yayına alıyorum; berberler için bir randevu sistemi geliştiriyorum.",
        en: "Since 2019 I've been building Next.js/React sites for small businesses and deploying them on VPS and Vercel; I'm currently building a booking system for barbers.",
      },
      problem: {
        tr: "Küçük işletmenin ihtiyacı estetik bir site değil, telefonda geçirdiği süreyi azaltan bir sistem.",
        en: "A small business doesn't need a beautiful site; it needs a system that shortens the time spent on the phone.",
      },
      solution: {
        tr: "Site ile randevu akışını tek parça olarak kuruyorum: müşteri saat seçiyor, işletme panelden görüyor, kimse birbirini aramak zorunda kalmıyor.",
        en: "I build the site and the booking flow as one piece: the customer picks a slot, the business sees it in a panel, and nobody has to call anyone.",
      },
      highlights: [],
    },
  },
  {
    slug: "kurumsal-kimlik",
    tier: "other",
    name: { tr: "Kurumsal Kimlik ve Grafik Tasarım", en: "Brand Identity and Graphic Design" },
    year: "2019+",
    org: { tr: "Bağımsız çalışma", en: "Independent work" },
    kind: { tr: "Görsel kimlik", en: "Visual identity" },
    status: { tr: "Devam ediyor", en: "Ongoing" },
    tagline: {
      tr: "20'den fazla marka için logo, kurumsal kimlik rehberi ve pazarlama materyali.",
      en: "Logos, brand guidelines and marketing material for more than 20 brands.",
    },
    gallery: [],
    metrics: [{ value: "20+", label: { tr: "marka", en: "brands" } }],
    stack: ["Adobe Photoshop", "Adobe Illustrator", "Figma", "Blender"],
    links: [],
    detail: {
      overview: {
        tr: "20'den fazla marka için kurumsal kimlik rehberi, logo ve dijital pazarlama materyali hazırladım.",
        en: "I've produced brand guidelines, logos and digital marketing material for more than 20 brands.",
      },
      problem: {
        tr: "Bir yazılımcının tasarımcıyla aynı dili konuşabilmesi, projenin gidişatını değiştiren bir şey. İkisini de yapabiliyor olmak, arayüz kararlarını çok daha hızlı almamı sağlıyor.",
        en: "A developer who can speak the designer's language changes how a project goes. Being able to do both lets me make interface decisions much faster.",
      },
      solution: {
        tr: "Bu sitedeki tipografi, renk ve düzen kararları da aynı yerden geliyor; arayüzü başka birine tarif etmek zorunda kalmıyorum.",
        en: "The typography, color and layout decisions on this site come from the same place; I never have to describe an interface to someone else.",
      },
      highlights: [],
    },
  },
  {
    slug: "oto-galeri-veritabani",
    tier: "other",
    name: { tr: "Oto Galerisi Veritabanı Mimarisi", en: "Car Dealership Database Architecture" },
    year: "2023",
    org: { tr: "Bağımsız çalışma", en: "Independent work" },
    kind: { tr: "Müşteri projesi · veritabanı", en: "Client project · database" },
    status: { tr: "Teslim edildi", en: "Delivered" },
    tagline: {
      tr: "Bir oto galerisinin isteğiyle araç, müşteri, satış ve stok verisini tek bir ilişkisel veritabanında topladım.",
      en: "At a car dealership's request, I brought vehicle, customer, sales and inventory data into a single relational database.",
    },
    gallery: [],
    metrics: [],
    stack: ["SQL", "RDBMS", "Normalizasyon", "İndeksleme"],
    links: [],
    detail: {
      overview: {
        tr: "Bir oto galerisi için sıfırdan ilişkisel veritabanı tasarladım; ayrıca bir şirketin bozulmuş ve verimsiz çalışan kullanıcı veritabanlarını normalize ederek optimize ettim.",
        en: "I designed a relational database from scratch for a car dealership, and separately normalized and optimized a company's broken, inefficient user databases.",
      },
      problem: {
        tr: "Kötü tasarlanmış bir şema, üzerine yazılan her sorguyu ve her özelliği zorlaştırır. Veri tekrarı yalnızca yer kaplamaz; er ya da geç tutarsızlığa dönüşür.",
        en: "A badly designed schema makes every query and every feature written on top of it harder. Duplicated data doesn't just take space; sooner or later it becomes inconsistency.",
      },
      solution: {
        tr: "Araç, müşteri, satış ve stok ilişkilerini normalize edip ACID tutarlılığını koruyacak şekilde kurdum, sık kullanılan sorgular için indeksledim.",
        en: "I normalized the vehicle, customer, sale and inventory relationships to preserve ACID consistency, and indexed for the queries that actually run often.",
      },
      highlights: [],
    },
  },
];

/* Kolaylık: bölümlerin kullandığı türetilmiş listeler */
export const featuredProjects = projects.filter((p) => p.tier === "featured");
export const otherProjects = projects.filter((p) => p.tier !== "featured");
export const findProject = (slug) => projects.find((p) => p.slug === slug);

/* ------------------------------------------------------------- EXPERIENCE */

export const experience = [
  {
    org: "NinMen Studio",
    place: { tr: "İzmir", en: "İzmir" },
    role: { tr: "Kurucu & Lead Developer", en: "Founder & Lead Developer" },
    period: { tr: "Mayıs 2026 — bugün", en: "May 2026 — present" },
    current: true,
    summary: {
      tr: "Kurduğum stüdyo. Ensafe, Spontano ve Cat Hunter'ı fikirden yayına taşıdım. Ticaret Sicili Takip'i bir hukuk bürosunun isteğiyle, avukatlarla birebir çalışarak geliştirdim; bugün lisansla satılıyor. Ensafe'in risk modelini kimya ve biyoloji mühendisleriyle birlikte kurduk.",
      en: "The studio I founded. I took Ensafe, Spontano and Cat Hunter from idea to release. I built the Trade Registry Tracker at a law firm's request, working one-on-one with the lawyers; today it sells by license. We built Ensafe's risk model together with chemistry and biology engineers.",
    },
  },
  {
    org: { tr: "Immeta Studio Oyun Geliştirme A.Ş.", en: "Immeta Studio Game Development" },
    place: { tr: "Kocaeli · Uzaktan", en: "Kocaeli · Remote" },
    role: { tr: "Oyun Geliştirme ve Yayıncılık Stajyeri", en: "Game Development & Publishing Intern" },
    period: { tr: "Haziran — Ağustos 2026", en: "June — August 2026" },
    summary: {
      tr: "Bir oyuna online co-op altyapısı kurdum, bir diğerinin yayın öncesi Steamworks verilerini analiz ettim ve 260+ içerik üreticisini önceliklendiren veri havuzunu yönettim.",
      en: "Built online co-op for one game, analyzed another's pre-launch Steamworks data, and ran the pool that prioritized 260+ content creators.",
    },
  },
  {
    org: { tr: "Toyota Yetkili Bayisi", en: "Toyota Authorized Dealer" },
    place: { tr: "İstanbul", en: "Istanbul" },
    role: { tr: "Veri Otomasyonu ve Fiyat Analizi Geliştiricisi", en: "Data Automation & Pricing Analytics Developer" },
    period: { tr: "Ocak — Nisan 2026", en: "January — April 2026" },
    summary: {
      tr: "Bayinin satış ekibiyle ihtiyacı birlikte tanımlayıp 21 markanın fiyatlarını izleyen ve rakiplerin gerçek satış fiyatını hesaplayan sistemi uçtan uca teslim ettim.",
      en: "Defined the need together with the dealer's sales team, then delivered end to end a system that tracks prices across 21 brands and computes competitors' real selling prices.",
    },
  },
  {
    org: "Mezz Solution",
    place: { tr: "Shenzhen, Çin · Uzaktan", en: "Shenzhen, China · Remote" },
    role: { tr: "Veri Analisti ve Yazılım Geliştirici", en: "Data Analyst & Software Developer" },
    period: { tr: "Ekim — Aralık 2025", en: "October — December 2025" },
    summary: {
      tr: "Çin'deki satış ekibiyle uzaktan çalışarak onların sözel müşteri kriterlerini bulanık mantıkla bir skorlama sistemine çevirdim; manuel veri incelemesi %80 kısaldı.",
      en: "Working remotely with the sales team in China, I turned their verbal lead criteria into a fuzzy-logic scoring system; manual data review time dropped by 80%.",
    },
  },
  {
    org: { tr: "Bağımsız Yazılım Geliştirici & Tasarımcı", en: "Independent Developer & Designer" },
    place: { tr: "Uzaktan", en: "Remote" },
    role: { tr: "Full-Stack, Yapay Zekâ, Otomasyon, Görsel Kimlik", en: "Full-Stack, AI, Automation, Visual Identity" },
    period: { tr: "Ocak 2019 — bugün", en: "January 2019 — present" },
    summary: {
      tr: "İşletmelerle birebir çalışarak web siteleri ve randevu sistemleri, veri kazıma ve mail otomasyonu araçları geliştirdim; 20'den fazla marka için kurumsal kimlik hazırladım.",
      en: "Working one-on-one with businesses, I've built websites and booking systems, scraping and mail automation tools, and brand identities for 20+ companies.",
    },
  },
];

/* --------------------------------------------------------------- TOOLKIT */

export const toolkit = [
  {
    area: { tr: "Web & Backend", en: "Web & Backend" },
    items: ["Next.js (SSR/SSG)", "React", "TypeScript", "Node.js", "FastAPI", "JWT / OAuth2", { tr: "Rol tabanlı yetkilendirme", en: "RBAC" }],
  },
  {
    area: { tr: "Mobil & Masaüstü", en: "Mobile & Desktop" },
    items: ["Capacitor", "Flutter", { tr: "Google Play yayın süreci", en: "Google Play release process" }, "Electron", "PyQt6", "Unity Netcode"],
  },
  {
    area: { tr: "Yapay Zekâ", en: "AI" },
    items: [
      { tr: "LLM entegrasyonu", en: "LLM integration" },
      { tr: "Sesli ve görüntülü AI asistanlar", en: "Voice and vision AI assistants" },
      { tr: "Görüntüden ürün/barkod tanıma", en: "Product/barcode recognition from images" },
      "PyTorch",
    ],
  },
  {
    area: { tr: "Veri & Otomasyon", en: "Data & Automation" },
    items: ["Web Scraping", "Selenium", "Playwright", { tr: "PDF veri çıkarma", en: "PDF data extraction" }, "SMTP / IMAP"],
  },
  {
    area: { tr: "Altyapı & Veritabanı", en: "Infrastructure & Databases" },
    items: ["Docker", { tr: "Linux VPS yönetimi", en: "Linux VPS" }, "Vercel", "PostgreSQL", "SQLite", "Redis", "CI/CD", "Git"],
  },
  {
    area: { tr: "Tasarım", en: "Design" },
    items: ["Figma (UI/UX)", "Adobe Photoshop", "Adobe Illustrator", "Blender"],
  },
];

/* -------------------------------------------------------------- EDUCATION */

export const education = {
  school: { tr: "Dokuz Eylül Üniversitesi", en: "Dokuz Eylül University" },
  program: { tr: "Bilgisayar Bilimleri, Fen Fakültesi · 4. sınıf", en: "Computer Science, Faculty of Science · final year" },
  period: "2021 — 2026",
  coursework: {
    tr: "Nesne yönelimli programlama, bilgisayar ağları ve protokolleri, algoritma tasarımı ve analizi, veritabanı yönetim sistemleri, sayısal çözümleme, yazılım sınama, bilgisayar cebiri, sayısal tasarım ve mantık kapıları.",
    en: "Object-oriented programming, computer networks and protocols, algorithm design and analysis, database management systems, numerical analysis, software testing, computer algebra, digital design and logic gates.",
  },
};

export const certificates = [
  { name: "Computer Programming", issuer: "University of London" },
  { name: "IBM Data Science Professional Certificate", issuer: "IBM" },
  { name: "Front-End Developer", issuer: "Meta" },
];

export const languages = [
  { name: { tr: "Türkçe", en: "Turkish" }, level: { tr: "Anadil", en: "Native" } },
  { name: { tr: "İngilizce", en: "English" }, level: "B2" },
];

/* ---------------------------------------------------- COMMAND PALETTE ⌘K */

export const suggestedQuestions = {
  tr: [
    "Ensafe'in risk motorunu nasıl kurdun?",
    "Ticaret Sicili Takip'i müşteriyle birlikte nasıl geliştirdin?",
    "Cat Hunter'da modelinin bozuk olduğunu nasıl fark ettin?",
    "Benim için şöyle bir sistem yazabilir misin?",
    "Hangi teknolojilerde en rahatsın?",
    "Seninle nasıl iletişime geçebilirim?",
  ],
  en: [
    "How did you build Ensafe's risk engine?",
    "How did you build the Trade Registry Tracker with the client?",
    "How did you find out your Cat Hunter model was broken?",
    "Could you build something like this for me?",
    "Which technologies are you strongest in?",
    "How do I get in touch with you?",
  ],
};

/* ------------------------------------------------------------------ UI */

export const ui = {
  tr: {
    nav: { work: "Çalışmalar", experience: "Deneyim", toolkit: "Araç kutusu", contact: "İletişim" },
    searchHint: "Ara, ya da bana sor",
    sections: {
      work: "Seçilmiş çalışmalar",
      workNote: "Bir karta tıkla, projenin tamamını anlatayım.",
      ledger: "Diğer çalışmalar",
      experience: "Nerede çalıştım",
      toolkit: "Araç kutusu",
      about: "Eğitim ve sertifikalar",
      contact: "İletişim",
    },
    problemLabel: "Durum",
    solutionLabel: "Ne yaptım",
    stackLabel: "Kullandıklarım",
    overviewLabel: "Kısaca",
    highlightsLabel: "Öne çıkanlar",
    outcomeLabel: "Sonuç",
    galleryLabel: "Ekranlar",
    linksLabel: "Bağlantılar",
    openProject: "İncele",
    backHome: "Tüm çalışmalar",
    nextProject: "Sıradaki proje",
    noImageYet: "Görsel henüz eklenmedi",
    contact: {
      lead: "Aklında bir proje varsa ya da ekibine birini arıyorsan, doğrudan yaz.",
      emailAction: "E-posta gönder",
      telegramAction: "Telegram'dan yaz",
      askAction: "Önce siteye sor",
      cvTr: "Türkçe CV (PDF)",
      cvEn: "English CV (PDF)",
    },
    palette: {
      placeholder: "Bir projeye git ya da bir soru sor…",
      goto: "Git",
      ask: "Onur'a sor",
      askThis: "Bunu Onur'a sor",
      suggestions: "Sıkça sorulanlar",
      error: "Bağlanamadım. Birazdan tekrar dener misin? Acelen varsa Telegram: @dikucgen",
      backToSearch: "Aramaya dön",
    },
    theme: { toDark: "Koyu tema", toLight: "Açık tema" },
    placeholderImage: "Görsel için: public/media/",
  },
  en: {
    nav: { work: "Work", experience: "Experience", toolkit: "Toolkit", contact: "Contact" },
    searchHint: "Search, or ask me",
    sections: {
      work: "Selected work",
      workNote: "Open a card and I'll walk you through the whole project.",
      ledger: "Other work",
      experience: "Where I've worked",
      toolkit: "Toolkit",
      about: "Education and certificates",
      contact: "Contact",
    },
    problemLabel: "The situation",
    solutionLabel: "What I built",
    stackLabel: "Built with",
    overviewLabel: "In short",
    highlightsLabel: "Highlights",
    outcomeLabel: "Outcome",
    galleryLabel: "Screens",
    linksLabel: "Links",
    openProject: "Open",
    backHome: "All work",
    nextProject: "Next project",
    noImageYet: "No image yet",
    contact: {
      lead: "If you have a project in mind, or you're looking for someone for your team, write to me directly.",
      emailAction: "Send an email",
      telegramAction: "Message on Telegram",
      askAction: "Ask the site first",
      cvTr: "Turkish CV (PDF)",
      cvEn: "English CV (PDF)",
    },
    palette: {
      placeholder: "Jump to a project, or ask a question…",
      goto: "Go to",
      ask: "Ask Onur",
      askThis: "Ask Onur this",
      suggestions: "Frequently asked",
      error: "Couldn't reach the server. Try again in a moment — or Telegram me: @dikucgen",
      backToSearch: "Back to search",
    },
    theme: { toDark: "Dark theme", toLight: "Light theme" },
    placeholderImage: "Drop an image at public/media/",
  },
};

/* Dile göre metin seçer: "düz metin" ya da {tr, en} kabul eder. */
export const t = (value, lang) => {
  if (value == null) return "";
  if (typeof value === "string") return value;
  if (Array.isArray(value)) return value;
  return value[lang] ?? value.tr ?? value.en ?? "";
};
